<template>
  <div id="hotels-second-search-bar"
       :class="[{'price-table-show': showPriceTableForLeftFilters}, {'vertical-filters': settings.FiltersDisplayOptions}]">
      <template v-if="settings.FiltersDisplayOptions && !getWindowSettings.commonFiltersForHotels">
          <second-search-bar-left @clearAllFilters-hotels="clearAllFilters(true, true)"
                                  @togglePriceTable="togglePriceTable($event)"
                                  @toggleFilterBlock="togglePriceTable($event)"
                                  @applyAllChanges="sendSecondFilterParams()"
                                  :rate="rate"
                                  :tour-settings="tourSettings"
                                  :availability-price="availabilityPrice"
                                  :availability-place="availabilityPlace"
                                  :tour-program-list="tourProgramList"
                                  :tour-program-checked="tourProgramChecked"
                                  :tour-cities-list="tourCitiesList"
                                  :tour-cities-checked="tourCitiesChecked"
                                  :tour-resort-list="tourResortList"
                                  :tour-resort-checked="tourResortChecked"
                                  :tour-category-list="tourCategoryList"
                                  :tour-category-checked="tourCategoryChecked"
                                  :tour-food-list="tourFoodList"
                                  :tour-food-checked="tourFoodChecked"
                                  :tour-hotel-type-list="tourHotelTypeList"
                                  :tour-hotel-type-checked="tourHotelTypeChecked"
                                  :tour-hotel-list="tourHotelList"
                                  :tour-hotel-checked="tourHotelChecked"
                                  :tour-class-list="tourClassList"
                                  :tour-class-multy="tourClassMulty"
                                  :tour-class-checked="tourClassChecked"
                                  :tour-transplantation-list="tourTransplantationList"
                                  :departure-time="departureTime"
                                  :arrival-time="arrivalTime"
                                  :tour-departure-list="tourDepartureList"
                                  :tour-departure-airports-checked="tourDepartureAirportsChecked"
                                  :tour-arrival-list="tourArrivalList"
                                  :tour-arrival-airports-checked="tourArrivalAirportsChecked"
                                  :tour-airline-list="tourAirlineList"
                                  :tour-airline-multy="tourAirlineMulty"
                                  :tour-airlines-checked="tourAirlinesChecked"
                                  :collapse="collapse"
                                  :price-loader="priceLoader"
                                  :tour-price-limit="tourPriceLimit"
                                  :left-filters-update="selectedFilters.length"
                                  :list-type="listType"
                                  :hide-hotel-type-combination="hideHotelTypeCombination"
                                  :tour-hotel-type-combination="tourHotelTypeCombination"
                                  :hide-hotel-check="hideHotelCheck"
                                  :tour-hotel-combination="tourHotelCombination"
                                  :headline-checkbox="headlineCheckbox"
                                  :show-selected-hotels="showSelectedHotels"/>
          <!--Фильтр матрица цен-->
          <price-table v-if="showPriceTableForLeftFilters"
                       id="hotels-price-table"
                       @changeCitiFrom="changeCitiFrom($event)"
                       @changeCityToStatus="changeCityToStatus($event)"
                       @setPriceFromTableCities="setPriceFromTableCities(...$event)"
                       @setAddintionalPrice="setAddintionalPrice(...$event)"
                       @addintionalPriceSlideLeft="addintionalPriceSlideLeft()"
                       @addintionalPriceSlideRight="addintionalPriceSlideRight()"
                       :cities-from="citiesFrom"
                       :cities-to="citiesTo"
                       :addintional-price-header="addintionalPriceHeader"
                       :addintional-price-items="addintionalPriceItems"
                       :addintional-price-header-all="addintionalPriceHeaderAll"
                       :addintional-price-items-all="addintionalPriceItemsAll"
                       :addintional-price="addintionalPrice"
                       :rate="rate"
                       :tour-settings="tourSettings"
                       :city-from-status="cityFromStatus"
                       :city-to-status="cityToStatus"
                       :slider-position="sliderPosition"
                       :create-price-table-columns-emitter="createPriceTableColumnsEmitter"
                       :price-table-ready="priceTableReady"
                       :price-table-loader="priceTableLoader" />
      </template>

    <div v-else-if="!getWindowSettings.commonFiltersForHotels" ref="secondFilters" id="secondFilters" :class="['second-search-bar-wrap', {'fixed': fixedFilters}]">

      <div :class="['second-search-bar',{'active': filterType}]">
        <div class="search-controlers">

          <!--Контролер доп филтров(навигация)-->
          <div @click="changeFilterType(4, true)" class="search-controler-item align-center">
            <span ref="filterIcon">{{localizeList.filters}}</span>
            <icon name="filter" class="angle-icon" width="20px" height="18px"  fill="#727272" />
          </div>
          <div v-if="showPriceTable"
               @click="changeFilterType(1)"
               :class="['search-controler-item align-center',{'active': filterType === 1}]">
            <span>{{localizeList.pricingTableUpper}}</span>
            <icon name="drop-angle" class="angle-icon" width="8px" height="5px" fill="#000" />
          </div>
          <div v-if="!getWindowSettings.hidePriceRangeFilterForHotels"
               @click="changeFilterType(2)"
               :class="['search-controler-item align-center',{'active': filterType === 2}]">
            <span>{{localizeList.availabilityUpper}}</span>
            <icon name="drop-angle" class="angle-icon" width="8px" height="5px" fill="#000" />

          </div>
          <div v-if="!getWindowSettings.hideTourOptionsFilterForHotels"
               @click="changeFilterType(3)"
               :class="['search-controler-item align-center',{'active': filterType === 3}]">
            <span>{{localizeList.tourOptionsUpper}}</span>
            <icon name="drop-angle" class="angle-icon" width="8px" height="5px" fill="#000" />

          </div>
          <div v-if="!getWindowSettings.hideAccommodationFilterForHotels"
               @click="changeFilterType(4)"
               :class="['search-controler-item align-center',{'active': filterType === 4}]">
            <span>{{localizeList.accommodation}}</span>
            <icon name="drop-angle" class="angle-icon" width="8px" height="5px" fill="#000" />

          </div>
        </div>

        <!--Контролер для отоброжения ресультатов(grid: сеткой, row: списком, map: пока не готово)-->
        <div class="result-positin-controlers">
          <div @click="collapseResult" class="collapse popover"
               @mouseleave="hidePopover()"
               @mouseenter="showPopover(getLocalizeByProp('groupTitle'), $event)">
            <icon name="collapse"
                  :fill="collapse ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                  width="20px" height="20px" />
          </div>
          <div @click="changeListType('grid')" class="controler popover"
               @mouseleave="hidePopover()"
               @mouseenter="showPopover(getLocalizeByProp('gridTitle'), $event)">
            <icon name="grid"
                  :fill="listType === 'grid' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                  width="20px" height="20px" />
          </div>
          <div @click="changeListType('big-row')" class="controler popover"
               @mouseleave="hidePopover()"
               @mouseenter="showPopover(getLocalizeByProp('bigRowTitle'), $event)">
            <icon name="big-row"
                  :fill="listType === 'big-row' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                  width="22px" height="22px" />
          </div>
          <div @click="changeListType('row')" class="controler popover"
               @mouseleave="hidePopover()"
               @mouseenter="showPopover(getLocalizeByProp('rowTitle'), $event)">
            <icon name="row"
                  :fill="listType === 'row' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                  width="20px" height="20px" />
          </div>
          <div @click="changeListType('map')" class="controler popover"
               @mouseleave="hidePopover()"
               @mouseenter="showPopover(getLocalizeByProp('mapTitle'), $event)">
            <icon name="map-icon"
                  :fill="listType === 'map' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                  width="20px" height="20px" />
          </div>
        </div>
      </div>

      <div v-show="filterType" :class="['second-search-bar-list relative',{'active': filterType}]"
           :style="{'paddingBottom': getPaddingBottom()}">

        <!--Фильтр матрица цен-->
        <price-table v-if="filterType === 1"
                     @changeCitiFrom="changeCitiFrom($event)"
                     @changeCityToStatus="changeCityToStatus($event)"
                     @setPriceFromTableCities="setPriceFromTableCities(...$event)"
                     @setAddintionalPrice="setAddintionalPrice(...$event)"
                     @addintionalPriceSlideLeft="addintionalPriceSlideLeft()"
                     @addintionalPriceSlideRight="addintionalPriceSlideRight()"
                     :cities-from="citiesFrom"
                     :cities-to="citiesTo"
                     :addintional-price-header="addintionalPriceHeader"
                     :addintional-price-items="addintionalPriceItems"
                     :addintional-price-header-all="addintionalPriceHeaderAll"
                     :addintional-price-items-all="addintionalPriceItemsAll"
                     :addintional-price="addintionalPrice"
                     :rate="rate"
                     :tour-settings="tourSettings"
                     :city-from-status="cityFromStatus"
                     :city-to-status="cityToStatus"
                     :slider-position="sliderPosition"
                     :create-price-table-columns-emitter="createPriceTableColumnsEmitter"
                     :price-table-ready="priceTableReady"
                     :price-table-loader="priceTableLoader" />

        <!-- Фильтр диапазон цен -->
        <div v-else-if="filterType === 2" class="availability-filter">
            <div v-show="priceLoader" class="price-loader">
                <base-loader size="50" weight="3" />
            </div>
            <!-- <div class="price-block">
      <p class="price-text">{{localizeList.priceUpper}}: <span class="blue-text">
                  {{correctPrice(availabilityPrice[0], true)}} {{getCurrencyDisplayBySettings(rate)}} – {{correctPrice(availabilityPrice[1], true)}} {{getCurrencyDisplayBySettings(rate)}}</span>
      </p>
      <base-slider v-model="availabilityPrice"
                   @change="changePrice($event)"
                   :size="tourPriceLimit"/>
    </div> -->
            <div class="common-price-block">
                <p class="price-text">{{localizeList.availabilityPriceRangeUpper}}</p>
                <div class="price-inputs">
                    <input type="text" class="price-input"
                           maxlength="9"
                           @input="(event) => availabilityPrice[0] = maskInputForNumber(event, 0)"
                           :value="availabilityPrice[0]"
                           @change="changePrice(availabilityPrice)">
                    <span class="dash"></span>
                    <input type="text" class="price-input"
                           maxlength="9"
                           @input="(event) => availabilityPrice[1] = maskInputForNumber(event, 0)"
                           :value="availabilityPrice[1]"
                           @change="changePrice(availabilityPrice)">
                </div>
            </div>
            <div class="done-btn">
                <base-button @click="clearAllFilters(true, true)" background="var(--lighten-6-color)" color="#727272">
                    {{localizeList.resetFlightsUpper}}
                </base-button>
                <base-button v-if="settings.UseApplyFiltersButton"
                             class="ml-5"
                             :disabled="loaderStatus"
                             @click="sendSecondFilterParams()">
                    <span v-if="!loaderStatus">{{localizeList.applyUpper}}</span>
                    <base-loader v-else width="84" size="22" weight="5" />
                </base-button>
            </div>
        </div>

        <!--Фильтр варианты туров-->
        <div v-else-if="filterType === 3" class="tour-options">
          <div class="tour-options-filter">
            <div class="tour-program">
              <div class="input-headline-checkbox-container">
                <p class="tour-options-headline">{{localizeList.tourProgram}}</p>
                <base-input v-model="searchProgram" 
                            class="program-search"
                            :placeholder="localizeList.titleUpper"
                            clearable>
                  <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>
                </base-input>
                <div v-if="tourProgramList.length" class="common-input-headline-checkbox-container">
                  <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                  <checkbox v-model="headlineCheckbox.tourProgram"
                            @change="changeTourProgram('all', $event)"
                            no-gap />
                </div>
              </div>
              <div class="options-list">
                <div v-for="(item, key) in tourProgramList"
                     :key="key">
                  <div v-if="item.isShow && !(item.isDisabled && !tourProgramChecked[item.Key])"
                       class="options-item">
                    <checkbox v-model="tourProgramChecked[item.Key]"
                              @change="changeTourProgram(item.Key, $event)">
                      <p class="ellipsis" :title="item.Name">
                        {{item.Name}}
                      </p>
                    </checkbox>
                    <span class="price-text">{{item.price}}</span>
                  </div>
                </div>
                <div v-show="!tourProgramList.length">
                  <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-group">
            <base-button @click="clearAllFilters(true, true)" background="var(--lighten-6-color)" color="#727272">
              {{localizeList.resetFlightsUpper}}
            </base-button>
            <base-button v-if="settings.UseApplyFiltersButton"
                         :disabled="loaderStatus"
                         @click="sendSecondFilterParams()">
              <span v-if="!loaderStatus">{{localizeList.applyUpper}}</span>
              <base-loader v-else width="84" size="22" weight="5"/>
            </base-button>
          </div>
        </div>

        <!--Фильтр размещение-->
        <div v-else-if="filterType === 4" class="tour-accommodation">
          <div class="tour-accommodation-filter">
            <div class="filter cities-filter">
              <div class="headline input-headline-checkbox-small-container">
                <p>{{localizeList.cityUpper}}</p>
                <div v-if="tourCitiesList.length" class="common-input-headline-checkbox-container">
                  <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                  <checkbox v-model="headlineCheckbox.cities"
                            @change="changeTourCities('all', $event)"
                            no-gap />
                </div>
              </div>
              <base-input v-model="searchCities" 
                          class="cities-search" 
                          :placeholder="localizeList.titleUpper"
                          clearable>
                <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>

              </base-input>
              <div class="accommodation-list search-list">
                <div v-for="(item, key) in tourCitiesList"
                     :key="key">
                  <div v-if="item.isShow && !(item.isDisabled && !tourCitiesChecked[item.Key])"
                       class="accommodation-item">
                    <checkbox v-model="tourCitiesChecked[item.Key]"
                              :disabled="item.isDisabledAndShow"
                              @change="changeTourCities(item.Key, $event)">
                      <span class="ellipsis" :title="item.name">{{item.name}}</span>
                    </checkbox>
                  </div>
                </div>
                <div v-show="!tourCitiesList.length">
                  <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                </div>
              </div>
            </div>
            <div class="filter resort-filter">
              <div class="headline input-headline-checkbox-small-container">
                <p>{{localizeList.resortUpper}}</p>
                <div v-if="tourResortList.length" class="common-input-headline-checkbox-container">
                  <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                  <checkbox v-model="headlineCheckbox.resorts"
                            @change="changeTourResort('all', $event)"
                            no-gap />
                </div>
              </div>
              <base-input v-model="searchResort" 
                          class="resort-search" 
                          :placeholder="localizeList.titleUpper"
                          clearable>
                <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>

              </base-input>
              <div class="accommodation-list search-list flex-column">
                <div v-for="(item, key) in tourResortList"
                     :key="key"
                     :style="{order: item.Key === -1 ? 1 : 2}">
                  <div v-if="item.isShow && !(item.isDisabled && !tourResortChecked[item.Key])" class="accommodation-item">
                    <checkbox v-model="tourResortChecked[item.Key]"
                              :disabled="item.isDisabledAndShow"
                              @change="changeTourResort(item.Key, $event)">
                      <span class="ellipsis" :title="item.Name">{{item.Name}}</span>
                    </checkbox>
                  </div>
                </div>
                <div v-show="!tourResortList.length">
                  <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                </div>
              </div>
            </div>
            <div class="filter category-filter">
              <div class="headline input-headline-checkbox-small-container">
                <p>{{localizeList.category|capitalize}}</p>
                <div v-if="tourCategoryList.length" class="common-input-headline-checkbox-container">
                  <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                  <checkbox v-model="headlineCheckbox.category"
                            @change="changeTourCategory('all', $event)"
                            no-gap />
                </div>
              </div>
              <base-input v-model="searchCategory" 
                          class="category-search"
                          :placeholder="localizeList.titleUpper"
                          clearable>
                <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>

              </base-input>
              <div class="accommodation-list search-list">
                <div v-for="(item, key) in tourCategoryList"
                     :key="key">
                  <div v-if="item.isShow && !(item.isDisabled && !tourCategoryChecked[item.Key])"
                       class="accommodation-item">
                    <checkbox v-model="tourCategoryChecked[item.Key]"
                              @change="changeTourCategory(item.Key, $event)">
                                        <span class="ellipsis"
                                              :title="item.Name|removeStar">{{item.Name|removeStar}}</span>
                    </checkbox>
                    <div style="height: 20px" v-if="getStars(item.Name) > 0" class="flex">
                      <icon name="star"
                            v-for="(item, key) in getStars(item.Name)"
                            :key="key"
                            class="star-icon" width="20px" height="20px" fill="var(--yellow-color)"/>

                    </div>
                  </div>
                </div>
                <div v-show="!tourCategoryList.length">
                  <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                </div>
              </div>
            </div>
            <div class="filter food-filter">
              <div class="headline input-headline-checkbox-small-container">
                <p>{{localizeList.pansionUpper}}</p>
                <div v-if="tourFoodList.length" class="common-input-headline-checkbox-container">
                  <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                  <checkbox v-model="headlineCheckbox.pansion"
                            @change="changeTourFood('all', $event)"
                            no-gap />
                </div>
              </div>
              <base-input v-model="searchFood" 
                          class="food-search" 
                          :placeholder="localizeList.titleUpper"
                          clearable>
                <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>

              </base-input>
              <div class="accommodation-list search-list">
                <div v-for="(item, key) in tourFoodList"
                     :key="key">
                  <div v-if="item.isShow && !(item.isDisabled && !tourFoodChecked[item.Key])"
                       class="accommodation-item">
                    <checkbox v-model="tourFoodChecked[item.Key]"
                              @change="changeTourFood(item.Key, $event)">
                                        <span class="ellipsis"
                                              :title="getFoodTitle(item)">{{getFoodTitle(item)}}</span>
                    </checkbox>
                  </div>
                </div>
                <div v-show="!tourFoodList.length">
                  <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                </div>
              </div>
            </div>
            <div class="br"></div>
            <div class="filter hotel-type-filter" v-if="!getWindowSettings.hideHotelTypeFilterForHotels">
              <div class="headlineCombination headline">
                <p>{{localizeList.hotelType}}</p>
                <div class="headlineCombinationInfo" v-show="hideHotelTypeCombination">
                    <div class="iconCombination"
                          @mouseleave="hidePopover()"
                          @mouseenter="showPopover(localizeList.hotelTypeCombinationDescr, $event)">
                        <icon name="help" width="14px" height="14px" fill="var(--primary-color)" />
                    </div>
                    <span :title="localizeList.hotelTypeCombinationUpper">
                        {{localizeList.hotelTypeCombinationUpper}}
                    </span>
                    <checkbox class="chekboxCombinationInfo" 
                              v-model="tourHotelTypeCombination" 
                              @change="changeTourHotelTypeCombination($event)"
                              no-gap />
                </div>
                </div>
              <div class="input-headline-checkbox-container">
                <base-input v-model="searchHotelType" 
                            class="hotel-type-search"
                            :placeholder="localizeList.titleUpper"
                            clearable>
                  <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>
                </base-input>
                <div v-if="tourHotelTypeList.length" class="common-input-headline-checkbox-container">
                  <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                  <checkbox v-model="headlineCheckbox.hotelType"
                            @change="changeTourHotelType('all', $event)"
                            no-gap />
                </div>
              </div>
              <div class="accommodation-list search-list">
                <div v-for="(item, key) in tourHotelTypeList"
                     :key="key">
                  <div v-if="item.isShow && !(item.isDisabled && !tourHotelTypeChecked[item.key])"
                       class="accommodation-item">
                    <checkbox v-model="tourHotelTypeChecked[item.key]"
                              @change="changeTourHotelType(item.key, $event)">
                      <div class="align-center ellipsis">
                        <img width="20px" height="20px" :src="getHotelTypeIcons(item.key)"
                             class="hotel-type-icon"/>
                        <span class="ellipsis" :title="item.name">{{item.name}}</span>
                      </div>
                    </checkbox>
                  </div>
                </div>
                <div v-show="!tourHotelTypeList.length">
                  <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                </div>
              </div>
            </div>
            <div class="filter hotel-filter">
                <div class="headlineCombination headline">
                  <p>{{localizeList.hotelUpper}} {{getTourHotelCheckedAmount}}</p>
                  <div class="headlineCombinationInfo-container">
                    <div class="headlineCombinationInfo" v-show="hideHotelCheck">
                        <div class="iconCombination"
                              @mouseleave="hidePopover()"
                              @mouseenter="showPopover(localizeList.hotelCombinationDescr, $event)">
                            <icon name="help" width="14px" height="14px" fill="var(--primary-color)" />
                        </div>
                        <span :title="localizeList.hotelCombinationUpper">
                            {{localizeList.hotelCombinationUpper}}
                        </span>
                        <checkbox class="chekboxCombinationInfo" 
                                  v-model="tourHotelCombination" 
                                  @change="changeTourHotelCombination($event)"
                                  no-gap />
                    </div>
                    <div class="headlineCombinationInfo" v-show="!headlineCheckbox.hotels">
                        <span :title="localizeList.showSelectedUpper">
                            {{localizeList.showSelectedUpper}}
                        </span>
                        <checkbox class="chekboxCombinationInfo" 
                                  v-model="showSelectedHotels" 
                                  @change="filterHotelsBySelected($event)"
                                  no-gap />
                    </div>
                  </div>
                </div>
                <div class="input-headline-checkbox-container">
                  <base-input v-model="searchHotel" 
                              class="hotel-search"
                              :placeholder="localizeList.titleUpper"
                              clearable>
                    <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>
                  </base-input>
                  <div v-if="tourHotelList.length" class="common-input-headline-checkbox-container">
                    <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                    <checkbox v-model="headlineCheckbox.hotels"
                              @change="changeTourHotel('all', $event)"
                              no-gap />
                  </div>
                </div>
                <div class="accommodation-list search-list">
                    <div v-for="(item, key) in tourHotelList"
                          :key="key">
                        <div v-if="item.isShow && !(item.isDisabled && !tourHotelChecked[item.Key])"
                              class="accommodation-item">
                            <checkbox v-model="tourHotelChecked[item.Key]"
                                      :disabled="item.isDisabledAndShow"
                                      @change="changeTourHotel(item.Key, $event)">
                                <span v-if="item.Resort != null" class="ellipsis" :title="item.Name + ' ' + (item.Stars || '')">
                                    {{item.Name + ' ' + (item.Stars || '')}} {{'(' + item.Resort.Name + ')'}}
                                </span>
                                <span v-else class="ellipsis" :title="item.Name + ' ' + (item.Stars || '')">
                                    {{item.Name + ' ' + (item.Stars || '')}}
                                </span>
                            </checkbox>
                        </div>
                    </div>
                    <div v-show="!tourHotelList.length">
                        <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                    </div>
                </div>
            </div>
          </div>
          <div class="btn-group">
            <base-button @click="clearAllFilters(true, true)" background="var(--lighten-6-color)" color="#727272">
              {{localizeList.resetFlightsUpper}}
            </base-button>
            <base-button v-if="settings.UseApplyFiltersButton"
                         :disabled="loaderStatus"
                         @click="sendSecondFilterParams()">
              <span v-if="!loaderStatus">{{localizeList.applyUpper}}</span>
              <base-loader v-else width="84" size="22" weight="5"></base-loader>
            </base-button>
          </div>
        </div>
      </div>

      <selected-filters
        v-if="selectedFilters.length && !filterType && !settings.FiltersDisplayOptions"
        :filters="selectedFilters"
        @change="changeSelectedFilters($event)"
        class="selected-filters"
        ref="selectedFilters"/>
    </div>

    <!-- Вариант отображения фильтров в одном окне -->
    <div v-else ref="secondFilters" id="secondFilters" :class="['second-search-bar-wrap', {'fixed': fixedFilters}]">

       <div v-if="tourSettings" class="common-search-bar-list"
           :style="{'paddingBottom': getPaddingBottom()}">

          <div class="common-filters">
            <div class="common-filters-container">

              <div class="top-block">
                <div class="top-left-block">
                  <div class="common-cities-filter">
                    <div class="common-headline-container">
                      <p class="common-headline">{{localizeList.cityUpper}}</p>
                      <div v-if="tourCitiesList.length" class="common-headline-checkbox-container">
                        <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                        <checkbox v-model="headlineCheckbox.cities"
                                  @change="changeTourCities('all', $event)"
                                  no-gap />
                      </div>
                    </div>
                    <div class="common-list">
                      <div v-for="(item, key) in tourCitiesList"
                          :key="key">
                        <div v-if="item.isShow && !(item.isDisabled && !tourCitiesChecked[item.Key])"
                            class="common-item">
                          <checkbox v-model="tourCitiesChecked[item.Key]"
                                    :disabled="item.isDisabledAndShow"
                                    @change="changeTourCities(item.Key, $event)">
                            <span class="ellipsis" :title="item.name">{{item.name}}</span>
                          </checkbox>
                        </div>
                      </div>
                      <div v-show="!tourCitiesList.length || tourCitiesList.every((item) => item.isDisabled)">
                        <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                      </div>
                    </div>
                  </div>

                  <div class="filter resort-filter common-resort-filter">
                    <div class="common-headline-container">
                      <p class="common-headline">{{localizeList.resortUpper}}</p>
                      <div v-if="tourResortList.length" class="common-headline-checkbox-container">
                        <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                        <checkbox v-model="headlineCheckbox.resorts"
                                  @change="changeTourResort('all', $event)"
                                  no-gap />
                      </div>
                    </div>
                    <div class="common-list">
                      <div v-for="(item, key) in tourResortList"
                          :key="key"
                          :style="{order: item.Key === -1 ? 1 : 2}">
                        <div v-if="item.isShow && !(item.isDisabled && !tourResortChecked[item.Key])"
                        class="common-item">
                          <checkbox v-model="tourResortChecked[item.Key]"
                                    :disabled="item.isDisabledAndShow"
                                    @change="changeTourResort(item.Key, $event)">
                            <span class="ellipsis" :title="item.Name">{{item.Name}}</span>
                          </checkbox>
                        </div>
                      </div>
                      <div v-show="!tourResortList.length || tourResortList.every((item) => item.isDisabled)">
                        <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="common-hotel-type-filter" v-if="!getWindowSettings.hideHotelTypeFilter">
                    <div class="common-headline-container">
                      <p class="common-headline">{{localizeList.hotelType}}</p>
                      <div v-if="tourHotelTypeList.length" class="common-headline-checkbox-container">
                        <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                        <checkbox v-model="headlineCheckbox.hotelType"
                                  @change="changeTourHotelType('all', $event)"
                                  no-gap />
                      </div>
                    </div>
                    <div class="common-headlineCombinationInfo" v-show="hideHotelTypeCombination">
                        <div class="common-iconCombination"
                            @mouseleave="hidePopover()"
                            @mouseenter="showPopover(localizeList.hotelTypeCombinationDescr, $event)">
                            <icon name="help" width="14px" height="14px" fill="var(--primary-color)" />
                        </div>
                        <span :title="localizeList.hotelTypeCombinationUpper">
                            {{localizeList.hotelTypeCombinationUpper}}
                        </span>
                        <checkbox class="common-chekboxCombinationInfo" 
                                  v-model="tourHotelTypeCombination" 
                                  @change="changeTourHotelTypeCombination($event)"
                                  no-gap>
                        </checkbox>
                    </div>
                    <div :class="['common-list', {'common-list-combination': hideHotelTypeCombination}]">
                      <div v-for="(item, key) in tourHotelTypeList"
                          :key="key">
                        <div v-if="item.isShow && !(item.isDisabled && !tourHotelTypeChecked[item.key])"
                            class="common-item">
                          <checkbox v-model="tourHotelTypeChecked[item.key]"
                                    @change="changeTourHotelType(item.key, $event)">
                            <div class="align-center ellipsis">
                              <img width="20px" height="20px" :src="getHotelTypeIcons(item.key)"
                                  class="hotel-type-icon"/>
                              <span class="ellipsis" :title="item.name">{{item.name}}</span>
                            </div>
                          </checkbox>
                        </div>
                      </div>
                      <div v-show="!tourHotelTypeList.length || tourHotelTypeList.every((item) => item.isDisabled)">
                        <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="top-right-block">
                    <div class="common-tour-program">
                      <div :class="['common-input-header',{'common-input-header-with-chekbox': tourProgramList.length}]">
                        <p class="common-headline common-input-headline">{{localizeList.tourProgram}}</p>
                        <base-input v-model="searchProgram" 
                                    class="common-program-search"
                                    :placeholder="localizeList.titleUpper"
                                    clearable>
                          <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>
                        </base-input>
                        <div v-if="tourProgramList.length" class="common-input-headline-checkbox-container">
                          <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                          <checkbox v-model="headlineCheckbox.tourProgram"
                                    @change="changeTourProgram('all', $event)"
                                    no-gap />
                      </div>
                      </div>
                      <div class="common-list common-input-list">
                        <div v-for="(item, key) in tourProgramList"
                            :key="key">
                          <div v-if="item.isShow && !(item.isDisabled && !tourProgramChecked[item.Key])"
                              class="common-item common-program-item">
                            <checkbox v-model="tourProgramChecked[item.Key]"
                                      @change="changeTourProgram(item.Key, $event)">
                              <p class="ellipsis" :title="item.Name">
                                {{item.Name}}
                              </p>
                            </checkbox>
                            <span class="common-price-text">{{item.price}}</span>
                          </div>
                        </div>
                        <div v-show="!tourProgramList.length || tourProgramList.every((item) => item.isDisabled)">
                          <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                        </div>
                      </div>
                    </div>
                </div>

              </div>

              <div class="bottom-block">
                  <div class="bottom-left-block">
                    <div class="top-row">
                      <div class="common-category-filter">
                      <div class="common-headline-container">
                        <p class="common-headline">{{localizeList.category|capitalize}}</p>
                        <div v-if="tourCategoryList.length" class="common-headline-checkbox-container">
                          <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                          <checkbox v-model="headlineCheckbox.category"
                                    @change="changeTourCategory('all', $event)"
                                    no-gap />
                        </div>
                      </div>
                        <div class="common-list">
                          <div v-for="(item, key) in tourCategoryList"
                              :key="key">
                            <div v-if="item.isShow && !(item.isDisabled && !tourCategoryChecked[item.Key])"
                                class="common-item">
                              <checkbox v-model="tourCategoryChecked[item.Key]"
                                        @change="changeTourCategory(item.Key, $event)">
                                                  <span class="ellipsis"
                                                        :title="item.Name">{{item.Name}}</span>
                              </checkbox>
                            </div>
                          </div>
                          <div v-show="!tourCategoryList.length || tourCategoryList.every((item) => item.isDisabled)">
                            <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="common-food-filter">
                        <div class="common-headline-container">
                          <p class="common-headline">{{localizeList.pansionUpper}}</p>
                          <div v-if="tourFoodList.length" class="common-headline-checkbox-container">
                            <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                            <checkbox v-model="headlineCheckbox.pansion"
                                      @change="changeTourFood('all', $event)"
                                      no-gap />
                          </div>
                        </div>
                        <div class="common-list">
                          <div v-for="(item, key) in tourFoodList"
                              :key="key">
                            <div v-if="item.isShow && !(item.isDisabled && !tourFoodChecked[item.Key])"
                                class="common-item">
                              <checkbox v-model="tourFoodChecked[item.Key]"
                                        @change="changeTourFood(item.Key, $event)">
                                                  <span class="ellipsis"
                                                        :title="getFoodTitle(item)">{{getFoodTitle(item)}}</span>
                              </checkbox>
                            </div>
                          </div>
                          <div v-show="!tourFoodList.length || tourFoodList.every((item) => item.isDisabled)">
                            <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="common-room-features-filter">
                        <div class="common-headline-container">
                          <p class="common-headline">{{localizeList.roomFeature}}</p>
                          <div v-if="tourRoomFeaturesList.length" class="common-headline-checkbox-container">
                            <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                            <checkbox v-model="headlineCheckbox.roomFeatures"
                                      @change="changeRoomFeatures('all', $event)"
                                      no-gap />
                          </div>
                        </div>
                        <div class="common-list">
                          <div v-for="(item, key) in tourRoomFeaturesList"
                              :key="key">
                            <div v-if="item.isShow && !(item.isDisabled && !tourRoomFeaturesChecked[item.Key])"
                                class="common-item">
                              <checkbox v-model="tourRoomFeaturesChecked[item.Key]"
                                        @change="changeRoomFeatures(item.Key, $event)">
                                <div class="align-center ellipsis">
                                  <span class="ellipsis" :title="item.Name">{{item.Name}}</span>
                                </div>
                              </checkbox>
                            </div>
                          </div>
                          <div v-show="!tourRoomFeaturesList.length || tourRoomFeaturesList.every((item) => item.isDisabled)">
                            <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
    
                    <div class="bottom-row">
                        <div class="common-availability-filter">
                            <div v-show="priceLoader" class="price-loader">
                                <base-loader size="50" weight="3" />
                            </div>
                            <div class="common-price-block">
                                <p class="price-text">{{localizeList.availabilityPriceRangeUpper}}</p>
                                <div class="price-inputs">
                                    <input type="text" class="price-input"
                                           maxlength="9"
                                           @input="(event) => availabilityPrice[0] = maskInputForNumber(event, 0)"
                                           :value="availabilityPrice[0]"
                                           @change="changePrice(availabilityPrice)">
                                    <span class="dash"></span>
                                    <input type="text" class="price-input"
                                           maxlength="9"
                                           @input="(event) => availabilityPrice[1] = maskInputForNumber(event, 0)"
                                           :value="availabilityPrice[1]"
                                           @change="changePrice(availabilityPrice)">
                                </div>
                            </div>
                            <div class="common-availability-checkbox-group-wrap">
                                <div class="mb-2 default">
                                    <div>
                                        <p><span>{{localizeList.defaultYesFilter}}</span></p>
                                        <p><span>{{localizeList.defaultYesRequestFilter}}</span></p>
                                        <p><span>{{localizeList.defaultAllFilter}}</span></p>
                                    </div>
                                    <div class="common-availability-checkbox-group">
                                        <div>
                                            <icon class="mb-2" name="hotel"
                                                  width="20px" height="20px"
                                                  :fill="'#1C88D6'" />

                                            <div v-for="(item, key) in defaultHotelFilter"
                                                 :key="key"
                                                 class="filter-item mb-2">

                                                <radio-btn :value="item.isChecked"
                                                           @change="changeTourPlace(item.value, 'hotelQuota')">
                                                </radio-btn>
                                            </div>
                                        </div>
                                        <!-- <div>
                                            <icon class="mb-2" name="flight"
                                                  width="20px" height="20px"
                                                  :fill="'#1C88D6'" />
                                            <div v-for="(item, key) in defaultAirFilter"
                                                 :key="key"
                                                 class="filter-item mb-2">
                                                <radio-btn :value="item.isChecked"
                                                           @change="changeTourPlace(item.value, 'aviaQuota')">
                                                </radio-btn>
                                            </div>
                                        </div> -->
                                        <!-- <div v-if="tourSettings.IsShowBusTransferPlaces">
                                            <icon class="mb-2" name="bus"
                                                  width="20px" height="20px"
                                                  :fill="'#1C88D6'" />
                                            <div v-for="(item, key) in defaultBusFilter"
                                                 :key="key"
                                                 class="filter-item mb-2">
                                                <radio-btn :value="item.isChecked"
                                                           @change="changeTourPlace(item.value, 'busTransferQuota')">
                                                </radio-btn>
                                            </div>
                                        </div> -->
                                        <!-- <div v-if="tourSettings.IsShowRwtTransferPlaces">
                                            <icon class="mb-2" name="train"
                                                  width="20px" height="20px"
                                                  :fill="'#1C88D6'" />
                                            <div v-for="(item, key) in defaultRailwayFilter"
                                                 :key="key"
                                                 class="filter-item mb-2">
                                                <radio-btn :value="item.isChecked"
                                                           @change="changeTourPlace(item.value, 'trainTransferQuota')">
                                                </radio-btn>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
    
                  <div class="bottom-right-block">
                      <div class="common-hotel-filter">
                          <div :class="['common-input-header',{'common-input-header-with-chekbox': tourHotelList.length}]">
                            <p class="common-headline common-input-headline">{{localizeList.hotelUpper}} {{getTourHotelCheckedAmount}}</p>
                            <base-input v-model="searchHotel" 
                                        class="hotel-search"
                                        :placeholder="localizeList.titleUpper"
                                        clearable>
                              <icon name="search" width="20px" height="20px" fill="var(--lighten-7-color)"/>
                            </base-input>
                            <div v-if="tourHotelList.length" class="common-input-headline-checkbox-container">
                              <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
                              <checkbox v-model="headlineCheckbox.hotels"
                                        @change="changeTourHotel('all', $event)"
                                        no-gap />
                          </div>
                          </div>
                          <div class="common-headlineCombinationInfo-container" v-show="hideHotelCheck">
                            <div class="common-headlineCombinationInfo">
                                <div class="common-iconCombination"
                                    @mouseleave="hidePopover()"
                                    @mouseenter="showPopover(localizeList.hotelCombinationDescr, $event)">
                                    <icon name="help" width="14px" height="14px" fill="var(--primary-color)" />
                                </div>
                                <span :title="localizeList.hotelCombinationUpper">
                                    {{localizeList.hotelCombinationUpper}}
                                </span>
                                <checkbox class="common-chekboxCombinationInfo" 
                                          v-model="tourHotelCombination" 
                                          @change="changeTourHotelCombination($event)"
                                          no-gap>
                                </checkbox>
                            </div>
                            <div class="common-headlineCombinationInfo">
                                <span :title="localizeList.showSelectedUpper">
                                    {{localizeList.showSelectedUpper}}
                                </span>
                                <checkbox class="common-chekboxCombinationInfo" 
                                          v-model="showSelectedHotels" 
                                          @change="filterHotelsBySelected($event)"
                                          no-gap>
                                </checkbox>
                            </div>
                          </div>
                          <div v-bind:class="{'common-list common-input-list-combination': hideHotelCheck, 'common-list common-input-list': !hideHotelCheck} ">
                              <div v-for="(item, key) in tourHotelList"
                                  :key="key">
                                  <div v-if="item.isShow && !(item.isDisabled && !tourHotelChecked[item.Key])"
                                      class="common-item">
                                      <checkbox v-model="tourHotelChecked[item.Key]"
                                                :disabled="item.isDisabledAndShow"
                                                @change="changeTourHotel(item.Key, $event)">
                                          <span v-if="item.Resort != null" class="ellipsis" :title="item.Name + ' ' + (item.Stars || '')">
                                              {{item.Name + ' ' + (item.Stars || '')}} {{'(' + item.Resort.Name + ')'}}
                                          </span>
                                          <span v-else class="ellipsis" :title="item.Name + ' ' + (item.Stars || '')">
                                              {{item.Name + ' ' + (item.Stars || '')}}
                                          </span>
                                      </checkbox>
                                  </div>
                              </div>
                              <div v-show="!tourHotelList.length || tourHotelList.every((item) => item.isDisabled)">
                                  <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
                              </div>
                          </div>
                          </div>
                  </div>
              </div>

            </div>

          <div class="btn-group">
              <!--Контролер для отоброжения ресультатов(grid: сеткой, row: списком, map: пока не готово)-->
              <div class="common-result-position-controlers">
                <div @click="collapseResult" class="collapse popover"
                    @mouseleave="hidePopover()"
                    @mouseenter="showPopover(getLocalizeByProp('groupTitle'), $event)">
                  <icon name="collapse"
                        :fill="collapse ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                        width="20px" height="20px" />
                </div>
                <div @click="changeListType('grid')" class="controler popover"
                    @mouseleave="hidePopover()"
                    @mouseenter="showPopover(getLocalizeByProp('gridTitle'), $event)">
                  <icon name="grid"
                        :fill="listType === 'grid' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                        width="20px" height="20px" />
                </div>
                <div @click="changeListType('big-row')" class="controler popover"
                    @mouseleave="hidePopover()"
                    @mouseenter="showPopover(getLocalizeByProp('bigRowTitle'), $event)">
                  <icon name="big-row"
                        :fill="listType === 'big-row' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                        width="22px" height="22px" />
                </div>
                <div @click="changeListType('row')" class="controler popover"
                    @mouseleave="hidePopover()"
                    @mouseenter="showPopover(getLocalizeByProp('rowTitle'), $event)">
                  <icon name="row"
                        :fill="listType === 'row' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                        width="20px" height="20px" />
                </div>
                <div @click="changeListType('map')" class="controler popover"
                    @mouseleave="hidePopover()"
                    @mouseenter="showPopover(getLocalizeByProp('mapTitle'), $event)">
                  <icon name="map-icon"
                        :fill="listType === 'map' ? 'var(--primary-color)' : 'var(--lighten-5-color)'"
                        width="20px" height="20px" />
                </div>
              </div>

            <div class="btn-subgroup">
                <base-button 
                @click="clearAllFilters(true, true)" 
                background="var(--lighten-6-color)" 
                color="#727272"
                minWidth="95">
                  {{localizeList.resetFlightsUpper}}
                </base-button>
  
                <base-button 
                    @click.native="search"
                    ref="searchButton"
                    background="var(--orange-color)"
                    minWidth="95"
                    padding="4px 24px">
                      <span v-if="!searchLoaderStatus">{{ localizeList.search }}</span>
                      <base-loader v-else size="22" weight="5"/>
                </base-button>
            </div>
          </div>

          </div>

      </div>

    </div>

    <selected-filters
      v-if="(selectedFilters.length && !filterType || selectedFilters.length) && settings.FiltersDisplayOptions && !getWindowSettings.commonFiltersForHotels"
      :filters="selectedFilters"
      @change="changeSelectedFilters($event)"
      class="selected-filters"
      ref="selectedFilters"/>
    <base-alert v-if="!alertDisabled">
        <template v-if="alertContent === 'grouping'">
            <p class="standard-500-text" style="max-width: 300px">
                {{localizeList.groupingWarning}}
            </p>
        </template>
        <template v-else-if="alertContent === 'info'">
            <p class="standard-500-text" style="max-width: 300px">
                {{localizeList.requestProcessingError}}
            </p>
        </template>
    </base-alert>
    <div v-show="fixedFilters" id="mainSecondFiltersSpace"></div>
  </div>
</template>

<script>
import selectedFilters from "../selectedFilters";

import {bus} from '../../../main'
import * as methods from '@/plugins/methods.js';

import * as typesGlobal from "@/stores/types";
import * as typesHotels from "@/stores/modules/hotels/types";
import * as mTypesHotels from "@/stores/modules/hotels/mutation_types";

import PriceTable from "./priceTable";
import SecondSearchBarLeft from "./leftFilters/secondSearchBarLeft";

export default {
  name: "second-search-bar",
  props: {
    searched: {
    type: Boolean,
    default: false
    },
  },
  components: {
    SecondSearchBarLeft,
    PriceTable,
    selectedFilters,
  },
  data() {
    return {
      API_URL: this.$store.getters['getApiUrl'],
      rate: null,
      tourSettings: null,
      focus: true,
      listType: "grid",
      filterType: 0,
      cashFilterType: 1,
      citiesFrom: [],
      cityFromStatus: -2,
      citiesTo: [],
      cityToStatus: -1,
      priceGroup: [],
      sliderPosition: 0,
      addintionalPriceHeader: [],
      addintionalPriceHeaderAll: [],
      addintionalPriceItems: [],
      addintionalPriceItemsAll: [],
      addintionalPrice: [],
      availabilityPrice: [],
      availabilityPlace: [false, false, false, false],
      tourProgramList: [],
      searchProgram: "",
      searchCities: "",
      searchResort: "",
      searchFood: "",
      searchCategory: "",
      searchHotel: "",
      searchHotelType: "",
      searchDeparture: "",
      searchArrival: "",
      searchAirline: "",
      tourCitiesList: [],
      tourResortList: [],
      tourCategoryList: [],
      tourFoodList: [],
      tourHotelTypeList: [],
      tourHotelList: [],
      tourMapHotelList: [],
      tourRoomFeaturesList: [],
      sendHotelsOnMap: false,
      tourClassMulty: {
        label: "Комбинировать классы",
        isChecked: false
      },
      tourTransplantationList: [
        {
          label: "withoutDirectUpper",
          value: 0,
          isChecked: false,
        },
        {
          label: "oneDirectUpper",
          value: 1,
          isChecked: false,
        },
        {
          label: "twoOrMoreDirectUpper",
          value: 2,
          isChecked: false,
        }
      ],
      tourTransplantationListTo: [
        {
          label: "withoutDirectUpper",
          value: 0,
          isChecked: false,
        },
        {
          label: "oneDirectUpper",
          value: 1,
          isChecked: false,
        },
        {
          label: "twoOrMoreDirectUpper",
          value: 2,
          isChecked: false,
        }
      ],
      tourDepartureList: [],
      tourArrivalList: [],
      tourAirlineMulty: {
        label: "Комбинировать компании",
        isChecked: false,
      },
      tourClassList: [],
      tourAirlineList: [],
      tourPriceLimit: [],
      departureTime: [0, 1439],
      arrivalTime: [0, 1439],
      tourProgramChecked: {},
      tourCitiesChecked: {},
      tourResortChecked: {},
      tourCategoryChecked: {},
      tourFoodChecked: {},
      tourHotelTypeChecked: {},
      tourHotelChecked: {},
      tourHotelTypeCombination: false,
      tourHotelCombination: false,
      tourClassChecked: {},
      tourDepartureAirportsChecked: {},
      tourArrivalAirportsChecked: {},
      tourAirlinesChecked: {},
      tourRoomFeaturesChecked: {},
      localSecondFilters: {
        price: [],
        AviaQuota: 7,
        HotelQuota: 7,
        BusTransferQuota: 7,
        RailwayTransferQuota: 7,
        tourProgram: [],
        tourCities: [],
        tourResort: [],
        tourCategory: [],
        tourHotel: [],
        tourFood: [],
        tourHotelType: [],
        tourClass: [],
        tourClassMulty: false,
        tourTransplantation: [],
        tourTransplantationTo: [],
        tourDepartureAirports: [],
        tourArrivalAirports: [],
        tourAirlines: [],
        tourAirlinesMulty: false,
        departureTime: ["00:00", "23:59"],
        arrivalTime: ["00:00", "23:59"],
      },
      loaderStatus: false,
      filtersChangeStatus: false,
      filterChange: [],
      priceChange: false,
      dTimeChange: false,
      aTimeChange: false,
      selectPriceTableCities: false,
      pageLoaderCountStatus: 0,
      selectedFilters: [],
      selectedFiltersOldVal: [], // Combo Tariff (delete)
      cashUrl: "",
      fixedFilters: false,
      currencyCorrectAfterChange: false,
      saveCurrency: [],
      cashSendSecondParams: '',
      cashLocalSecondParams: '',
      // hasOutSystem: false,
      priceTableLoader: false,
      priceTableReady: false,
      priceTableOutSystemReady: false,
      priceLoader: false,
      createPriceTableColumnsEmitter: 0,
      alertDisabled: true,
      alertContent: 'grouping',
      cashHotelOnMap: "",
      collapse: false,
      collapseLoad: false,
      groupByHotel: false,
      showPriceTableForLeftFilters: false,
      leftFiltersUpdate: 0,
      hideHotelCheck: false,
      hideHotelTypeCombination: false,
      defaultAirFilter: [],
      defaultHotelFilter: [],
      defaultBusFilter: [],
      defaultRailwayFilter: [],
      quotaItems: [
        {
            isChecked: false,
            value: 1
        },
        {
            isChecked: false,
            value: 5
        },
        {
            isChecked: false,
            value: 7
        }
      ],
      headlineCheckbox: {
        cities: false,
        resorts: false,
        hotelType: false,
        tourProgram: false,
        category: false,
        pansion: false,
        roomFeatures: false,
        hotels: false
      },
      showSelectedHotels: false,
      statePriceTable: false
    }
  },
  created() {
    bus.$on("change-search-type", (val) => {
      this.$nextTick(() => {
         if (val === 'hotels' && this.settings.FiltersDisplayOptions) this.togglePriceTable(this.statePriceTable);
      })
    })
    bus.$on("price-loader-hotels", (val) => {
      this.priceLoader = val;
    }),
    bus.$on("fixed-filters", (val) => {
      if (val) {
        this.cashFilterType = this.filterType;
        this.hide();
      } else {
        this.filterType = this.cashFilterType;
        if (this.filterType === 1) {
          setTimeout(() => {
            this.createPriceTableColumns()
          }, 0)
        }
        this.$nextTick(() => {
          this.resize()
        })
      }

      const mainFiltersTop = document.getElementById('main-filters').clientHeight;
      if (this.$refs.secondFilters)
        this.$refs.secondFilters.style.top = val ? mainFiltersTop + "px" : "";
      this.fixedFilters = val;
    });
    bus.$on("hotels_collapse", (val) => {
      this.collapse = val
    });
    bus.$on("tour_selectHotel_hotels", (keys) => {
      keys.forEach(x => {
        this.tourHotelChecked[x] = true;
      });
      bus.$emit("page-load", true);
      this.sendSecondFilterParams(true, true).then(() => {
        bus.$emit("page-load", false);
      });
    });
    bus.$on("localizeCode", () => {
      setTimeout(() => {
        this.resize()
      }, 100)
    });
    bus.$on("searched-for-hotels", () => {
      this.priceTableReady = false;
      this.priceTableOutSystemReady = false;
      if (this.filterType === 1) {
        const settings = this.$store.getters['getSettings'];
        const listTypeDefault = window.settings.additionalFilterOpenForHotels !== undefined ? window.settings.additionalFilterOpenForHotels : settings.ExtraFilterToShowInSearch;
        if (this.showPriceTable && listTypeDefault === 1) {
          this.priceTableReady = true;
          this.priceTableLoader = true;
          setTimeout(this.checkPriceTable, 500);
        }

        this.changeFilterType(1);
        this.changeFilterType(1);
      }
      // this.$nextTick(() => {
      //   if (
      //     this.$route.fullPath.includes('minPrice') ||
      //     this.$route.fullPath.includes('maxPrice') ||
      //     this.filterType === 2
      //   ) {
      //     this.getMaxPrice(true)
      //   }
      // })
    });
    // для обновления фильтра диапазон цен в компоненте navbar.vue функции commonSearch
    bus.$on("getMaxPrice-hotels", () => {
      this.getMaxPrice()
    });
    bus.$on("min-max-price-hotels", (data) => {
      let price = data.price;
      let searchParams = this.$route.params.searchParams;
      this.tourPriceLimit = price.slice();
      const isTickets = this.$route.fullPath.includes("Individuals/Avia");

      if ((!searchParams || !searchParams.includes("minPrice") && !searchParams.includes("maxPrice")) && !isTickets) {
        this.availabilityPrice = price.slice();
        this.localSecondFilters.price = price.slice();
      }

      if (
        this.availabilityPrice[0] < this.tourPriceLimit[0] && this.availabilityPrice[1] > this.tourPriceLimit[1] ||
        this.availabilityPrice[0] > this.tourPriceLimit[1] || this.availabilityPrice[1] < this.tourPriceLimit[0]
      ) {
        this.priceChange = false;
        this.removePrice();

        this.availabilityPrice[0] = this.tourPriceLimit[0];
        this.availabilityPrice[1] = this.tourPriceLimit[1];
        this.sendSecondFilterParams()
      } else if (this.availabilityPrice[0] < this.tourPriceLimit[0]) {
        this.removePrice([this.tourPriceLimit[0], this.availabilityPrice[1]]);

        this.availabilityPrice[0] = this.tourPriceLimit[0];
        this.sendSecondFilterParams()
      } else if (this.availabilityPrice[1] > this.tourPriceLimit[1]) {
        this.removePrice([this.availabilityPrice[0], this.tourPriceLimit[1]]);

        this.availabilityPrice[1] = this.tourPriceLimit[1];
        this.sendSecondFilterParams()
      }
    });
    bus.$on("searched-client-hotels", () => {
      this.cashSendSecondParams = "";
      this.currencyCorrectAfterChange = false;
      this.clearAllFilters();
      this.setSecondFilters();
      this.removeHotelsOnMap();
      this.$nextTick(() => {
        this.checkInputFilterValue(); // Обновляем данные в инпутах контекстного поиска
      })

      let searchParams = this.$route.params.searchParams;
      if (searchParams) {

        if(searchParams !== this.$route.params.searchParams) {
          this.$router.push(searchParams)
        }

        if (this.isOutHotel) {
          return
        }

        if (this.getWindowSettings.commonFiltersForHotels && !this.getShowTourResultList && this.getSearchSecondParamsCounter > 0) {
          return // Если включена опция commonFiltersForHotels, то не делает автоматический поиск при смене страны после использования фильтров
        }

        setTimeout(() => {
          this.checkCorrectUrl();

          this.changeSecondFiltersOfUrl().then(() => {
            // this.changePriceTableByUrl();
            // if (
            //   this.$route.fullPath.includes('minPrice') ||
            //   this.$route.fullPath.includes('maxPrice') ||
            //   this.filterType === 2
            // ) {
            //   this.getMaxPrice(true)
            // }
          })
        }, 0)
      }
    });
    bus.$on('out-sistem-searched-hotels', () => {
      this.setSecondFilters();
      this.$nextTick(() => {
        this.checkInputFilterValue(); // Обновляем данные в инпутах контекстного поиска
      })
      this.changeSecondFiltersOfUrl().then(() => {
        // this.changePriceTableByUrl()
        const priceTableIsChanged =
          this.$route.fullPath.includes("cityTo") ||
          this.$route.fullPath.includes("cityFrom") ||
          this.$route.fullPath.includes("currentDate");

        if (priceTableIsChanged)
          this.getPriceTable();

        if (this.groupByHotel) {
          this.collapseResult()
        }
      });

      if (this.priceTableReady && !this.priceTableOutSystemReady) {
        this.priceTableLoader = true;
        this.$store.dispatch('hotels/A_GET_PRICE_TABLE_OUT_HOTEL')
          .then(() => {
            this.priceTableLoader = false;
            this.priceTableOutSystemReady = true;
          })
          .catch(() => {
              this.priceTableLoader = false;
              this.alertContent = 'info';
            this.setAlertDisabled(5000);
            this.$store.dispatch('A_SET_ALERT', 5000);
          });
      }
    });
    bus.$on("changeCurrency", (val) => {
      if (!val) return;
      this.saveCurrency = [...val];

      this.convertPrice(val)
        .then(res => {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CONVERT_PRICE_FLAG, true)
          this.afterConvertPrice(res);
          this.saveCurrency = [];
        })
    });
    bus.$on("map_selected_hotel_for_hotelsTab", hotelKey => {
      this.tourMapHotelList = [];

      bus.$emit("page-load", true);
      this.sendHotelsOnMap = true;
      let selected = false;
      this.tourHotelList.forEach(x => {
        const hasHotel = hotelKey === x.Key;
        if (!hasHotel) return;

        selected = true;
        this.tourMapHotelList.push({...x});
        this.sendSecondFilterParams()
          .then(() => {
            bus.$emit("page-load", false);
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            })
          })
      });
      if (!selected) {
        this.sendSecondFilterParams()
          .then(() => {
            bus.$emit("page-load", false);
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            })
          })
      }
    });
    bus.$on("clearAllFilters-hotels", (apply, clientClick) => {
      if (this.checkFilterSelect) this.clearAllFilters(apply, clientClick);
    });
    window.addEventListener("resize", this.resize);
    window.addEventListener("scroll", this.scroll);

    // let configGroup = document.getElementById('defaultGroupSearchResults')?.value;
    let configGroup = window.settings.defaultGroupSearchResults;
    this.groupByHotel = this.$route.fullPath.includes("groupingKeys=32") || configGroup;

    window.onpopstate = this.onpopstate;
  },
  mounted() {
    this.rate = JSON.parse(localStorage.getItem("Rate")) ? JSON.parse(localStorage.getItem("Rate")) : {};
    this.setDefaultListType();
    this.localSecondFilters.price = this.tourPriceLimit.slice();
    this.getSettings();
    this.setSecondFilters();
    this.checkCorrectUrl();
    this.toggleSecondFiltersInfo();
    if (this.getWindowSettings.commonFiltersForHotels) {
        this.initialDefaultQuota();
    }

    if (!this.isOutHotel) {
      setTimeout(() => {
        this.changeSecondFiltersOfUrl().then(() => {
          // this.changePriceTableByUrl()
          const priceTableIsChanged =
            this.$route.fullPath.includes("cityTo") ||
            this.$route.fullPath.includes("cityFrom") ||
            this.$route.fullPath.includes("currentDate");

          if (priceTableIsChanged)
            this.getPriceTable();

          if (this.groupByHotel) {
            this.collapseResult()
          }
        });
      },0)
    }

    if (this.priceTableData) {
      this.setPriceTableData()
    }

    const settings = this.$store.getters['getSettings'];
    let type = window.settings.additionalFilterOpenForHotels !== undefined ? window.settings.additionalFilterOpenForHotels : settings.ExtraFilterToShowInSearch;
    type = type < 6 && type > 0 ? type : null;

    if (type) this.changeFilterType(type);
  },
  computed: {
    getTourHotelCheckedAmount() {
      const selectedHotels = Object.values(this.tourHotelChecked).filter(x => x === true);
      if (this.showSelectedHotels) {
        return `(${selectedHotels.length})`;
      } else if (!selectedHotels.length && this.tourHotelList.length) {
        return `(${this.tourHotelList.length})`;
      } else if (selectedHotels.length && this.tourHotelList.length) {
        return `(${selectedHotels.length}/${this.tourHotelList.length})`;
      } else {
        return "";
      }
    },
    getFilterParams() {
      return this.$store.getters['hotels/getFilterParams']
    },
    getMainSearchCount() {
      return this.$store.getters['hotels/getMainSearchCount']
    },
    getSearchSecondParamsCounter(){
      return this.$store.getters['hotels/getSearchSecondParamsCounter']
    },
    getShowTourResultList(){
      return this.$store.getters['hotels/getShowTourResultList']
    },
    searchLoaderStatus() {
      return this.$store.getters['hotels/getSearchLoaderStatus']
    },
    getWindowSettings() {
    return window.settings;
    },
    easySearchFilterForHotels() {
      return window.settings.easySearchFilterForHotels
    },
    settings() {
      return this.$store.getters['getSettings'];
    },
    hasOutSystem() {
      return this.$store.getters['hotels/getSearchInOut']
    },
    showPriceTable() {
      const settings = this.$store.getters['getSettings'];
      return window.settings.priceTableOpenForHotels !== undefined ? window.settings.priceTableOpenForHotels : settings.ShowPriceTableInSearch
    },
    usePansionGlobalCode() {
      return this.tourSettings?.UsePansionGlobalCodeInDopFilter
    },
    useHotelCategoryGlobalCode() {
      return this.tourSettings?.UseHotelCategoryGlobalCodeInDopFilter
    },
    isOutHotel() {
      return this.$store.getters['hotels/getSearchInOut']
    },
    secondFilters() {
      return this.$store.getters['hotels/getSecondaryFiltersResult']
    },
    cashSecondFilters() {
      return this.$store.getters['hotels/getCashSecondaryFiltersResult']
    },
    priceTableData() {
      let res = null;
      if (this.$store.getters['hotels/getPriceTableData']) {
        res = this.$store.getters['hotels/getPriceTableData']
      }
      return res
    },
    priceTableDataCities() {
      let res = null;
      if (this.$store.getters['hotels/getPriceTableDataCities']) {
        res = this.$store.getters['hotels/getPriceTableDataCities']
      }
      return res
    },
     checkFilterSelect() {
      const acc = {
        ...this.tourProgramChecked,
        ...this.tourCategoryChecked,
        ...this.tourFoodChecked,
        ...this.tourHotelTypeChecked,
        ...this.tourCitiesChecked,
        ...this.tourResortChecked,
        ...this.tourClassChecked,
        ...this.tourHotelChecked,
        ...this.tourRoomFeaturesChecked
      }

      if (!Object.keys(acc).length) return false

      const spreadedArr = [...Object.values(acc)]
      const hasChecked = spreadedArr.some((item) => item === true)
      const hasCheckedPrice = this.availabilityPrice.some((item) => item)

      return hasChecked || hasCheckedPrice
     },
     checkFilterSelectForCategory() {
      const acc = {
        ...this.tourProgramChecked,
        ...this.tourFoodChecked,
        ...this.tourHotelTypeChecked,
        ...this.tourClassChecked,
        ...this.tourRoomFeaturesChecked
      }

      if (!Object.keys(acc).length) return false

      const spreadedArr = [...Object.values(acc)]
      const hasChecked = spreadedArr.some((item) => item === true)
      const hasCheckedPrice = this.availabilityPrice.some((item) => item)

      return hasChecked || hasCheckedPrice
     }
  },
  methods: {
    setFiltersParamsInUrlNotRequest({ params, values, type }) {
      const currentUrl = this.$route.params.searchParams;
      let newUrl = currentUrl.split("&");
      let changeHotels = false;

      const filterAndSortHotels = (hotelList, values, resorts, cities) => {
        return this.$store.getters['quicksort'](hotelList, "Name").map(x => {
          const show = (values.length ? values.includes(x.Category?.Key) : true || !x.Category)
                        && (resorts.length ? resorts.includes(x.Resort?.Key) : true || !x.Resort)
                        && (cities.length ? cities.includes(x.City?.Key) : true || !x.City);
          x.isShow = show;
          x.isDisabled = !show;
          return x;
        })
      }

      if (type === "tourCategory") {
        const resorts = Object.entries(this.tourResortChecked).filter(x => x[1] === true).map(x => +x[0]);
        const cities = Object.entries(this.tourCitiesChecked).filter(x => x[1] === true).map(x => +x[0]);
        const cashHotelList = this.cashSecondFilters.Hotels;
        // Добавил, т.к. из внешних стали приходить дубликаты
        const uniqueCashHotelList = cashHotelList.filter((x, i) => cashHotelList.findIndex(y => y.Key === x.Key) === i);

        this.tourHotelList = filterAndSortHotels(uniqueCashHotelList, values, resorts, cities);
      }

      const checkedHotels = Object.keys(this.tourHotelChecked).filter(x => this.tourHotelChecked[x]).map(x => +x);
      const checkHotelListOnChecked = this.tourHotelList.some(x => checkedHotels.includes(x.Key));

      if (!checkHotelListOnChecked) this.searchHotel = ""

      checkedHotels.forEach(x => {
        if (!this.tourHotelList.find(x2=> x2.Key === x) && !checkHotelListOnChecked) {
          this.$set(this.tourHotelChecked, x, false);
          changeHotels = true;
        }

      })
      if (values.length) {
        newUrl = changeHotels ? newUrl.filter(x => !x.includes(params) && !x.includes("hotels") && !x.includes("hotelCombination")).join("&") : newUrl.filter(x => !x.includes(params) && !x.includes("hotelCombination")).join("&");
        newUrl = `${newUrl}&${params}=${values.join(",")}`;

        if (changeHotels) {
          newUrl = checkHotelListOnChecked.length ? `${newUrl}&hotels=${checkHotelListOnChecked.map(x => x.Key).join(",")}` : newUrl;
        }

        if (this.tourHotelCombination) {
          newUrl = `${newUrl}&hotelCombination=${this.tourHotelCombination}`
        }

        if (newUrl !== currentUrl) this.$router.push({ path: newUrl });
      } else {
        newUrl = newUrl.filter(x => !x.includes(params) && !x.includes("hotelCombination")).join("&");
        if (newUrl !== currentUrl) this.$router.push({ path: newUrl });
        this.$store.commit("hotels/" + mTypesHotels.M_SET_FILTER_PARAMS, {...this.getFilterParams, [type]: []});
      }

      this.checkInputFilterValue();
    },
    filterHotelsBySelected(val) {
      if (val) {
        this.tourHotelList = this.tourHotelList.map(x => {
          !this.tourHotelChecked[x.Key] ? x.isShow = false : x.isShow = true
          return x
        })
      } else {
        this.tourHotelList = this.tourHotelList.map(x => {
          x.isShow = true
          return x
        })
      }
    },
    checkInputFilterValue() {
      if (this.searchProgram.length) {
        this.tourProgramList = this.tourProgramList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchProgram.toLowerCase()) && !x.price.includes(this.searchProgram)) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourProgramList = this.tourProgramList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchCities.length && this.getWindowSettings.commonFiltersForHotels) {
        this.tourCitiesList = this.tourCitiesList.map(x => {
          if (!x.name.toLowerCase().includes(this.searchCities.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourCitiesList = this.tourCitiesList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchResort.length && this.getWindowSettings.commonFiltersForHotels) {
        this.tourResortList = this.tourResortList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchResort.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourResortList = this.tourResortList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchCategory.length) {
        this.tourCategoryList = this.tourCategoryList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchCategory.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourCategoryList = this.tourCategoryList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchFood.length) {
        this.tourFoodList = this.tourFoodList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchFood.toLowerCase()) && !x.Code.toLowerCase().includes(this.searchFood.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourFoodList = this.tourFoodList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchHotel.length) {
        this.tourHotelList = this.tourHotelList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchHotel.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourHotelList = this.tourHotelList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchHotelType.length) {
        this.tourHotelTypeList = this.tourHotelTypeList.map(x => {
          if (!x.name.toLowerCase().includes(this.searchHotelType.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourHotelTypeList = this.tourHotelTypeList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchDeparture.length) {
        this.tourDepartureList = this.tourDepartureList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchDeparture.toLowerCase()) && !x.Code.toLowerCase().includes(this.searchDeparture.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourDepartureList = this.tourDepartureList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchArrival.length) {
        this.tourArrivalList = this.tourArrivalList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchArrival.toLowerCase()) && !x.Code.toLowerCase().includes(this.searchArrival.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourArrivalList = this.tourArrivalList.map(x => {
          x.isShow = true;
          return x
        })
      }

      if (this.searchAirline.length) {
        this.tourAirlineList = this.tourAirlineList.map(x => {
          if (!x.Name.toLowerCase().includes(this.searchAirline.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourAirlineList = this.tourAirlineList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    addMinMaxPriceToUrl(minPrice, maxPrice) {
      let currentUrl = this.$route.params.searchParams;
      let newUrl = currentUrl.split("&");
      newUrl = newUrl.filter(x => !x.includes("minPrice") && !x.includes("maxPrice")).join("&")

      if (minPrice) newUrl = `${newUrl}&minPrice=${minPrice}`
      if (maxPrice) newUrl = `${newUrl}&maxPrice=${maxPrice}`
      
      if(newUrl === currentUrl) return
      this.$router.replace({ path: newUrl })
    },
    search() {
      this.$store.commit("hotels/" + mTypesHotels.M_SET_CHECK_FILTER_SELECT, this.checkFilterSelect) // Передаем информацию о фильтрах
      if (!this.checkFilterSelect) this.$store.commit("hotels/" + mTypesHotels.M_SET_SEARCH_SECOND_PARAMS_COUNTER, 0) // Для того, что-бы показывало результаты первого поиска без фильтров, после поиска с фильтрами
      bus.$emit("main-search-hotels");
      this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, true)
    },
    toggleSecondFiltersInfo() {
      const showFilterAlert = window.localStorage.getItem("showFilterAlert");
      if (showFilterAlert === "false") return;

      const filterBtn = {
        target: this.$refs.filterIcon
      }
      window.hideFilterAlert = () => {
        this.hidePopover();
        window.localStorage.setItem("showFilterAlert", "false")
      }

      const content = `
                <div>
                    <p>${this.localizeList.additionalFilters}</p>
                    <span onclick="hideFilterAlert()" class="blue-text-small pointer">${this.localizeList.doNotShowAgain}</span>
                </div>
                `;

      if (!filterBtn.target) return;

      this.showPopover( content, filterBtn, true);
      setTimeout(() => {
        this.hidePopover();
      }, 5000)
    },
    onpopstate() {
      if (
        this.$route.fullPath.includes("groupingKeys=32") && !this.collapse ||
        !this.$route.fullPath.includes("groupingKeys=32") && this.collapse
      ) {
        this.collapseResult();
      }
    },
    collapseResult() {
        if (!this.getShowTourResultList) return;
        const href = this.$route.fullPath.split("&");
        const durations = href
            .find(x => x.includes("durations="))
            .split("=")[1]
            .split(",");
        const isMinPrice = this.$route.fullPath.includes("minPrice=");
        const isGrouping = this.$route.fullPath.includes("groupingKeys=32");
        if (durations.length > 1 && isMinPrice && !isGrouping) {
            this.alertContent = 'grouping';
            this.setAlertDisabled(10000);
            this.$store.dispatch('A_SET_ALERT', 5000);
        }
      bus.$emit("page-load", true);
      this.collapseLoad = true;
      this.$store.dispatch("hotels/A_COLLAPSE_BY_HOTEL", this.collapse)
        .then(() => {
          this.collapse = !this.collapse;
          bus.$emit("hotels_collapse", this.collapse);
          bus.$emit("page-load", false);
          this.collapseLoad = false;
        })
    },
    removeHotelsOnMap() {
      const newUrl = this.$route.fullPath
        .split("&")
        .filter(x => !x.includes("hotelOnMap"))
        .join("&");

      if (this.$route.fullPath !== newUrl) {
        this.$router.push(newUrl);
      }
    },
    getPaddingBottom() {
      return this.filterType === 3 || this.filterType === 4 || this.filterType === 5 ? "20px" : ""
    },
    checkCorrectUrl() {
      const href = this.$route.fullPath.split("&");
      let currentDate = href.find(x => x.includes("currentDate"));

      if (currentDate) {
        currentDate = currentDate.split("=")[1];
        const dates = href
          .find(x => x.includes("dates="))
          .split("=")[1]
          .split(",") ;

        const hasCurrentDate = dates.includes(currentDate);
        if (!hasCurrentDate) {
          const newUrl = href
            .filter(x => !x.includes("currentDate") && !x.includes("currentDuration"))
            .join("&");

          if (this.$route.fullPath !== newUrl) {
            this.$router.push(newUrl);
            this.addintionalPrice = [];
          }
        }
      }
    },
    checkPriceTable() {
      if (this.addintionalPriceHeaderAll.length) {
        this.createPriceTableColumns();
        this.priceTableLoader = false;
        this.priceTableReady = true;

        if (this.hasOutSystem && !this.priceTableOutSystemReady) {
          this.priceTableLoader = true;
          this.priceTableOutSystemReady = true;
          this.$store.dispatch('hotels/A_GET_PRICE_TABLE_OUT_HOTEL')
            .then(() => {
              this.priceTableLoader = false;
              // this.priceTableOutSystemReady = true;
            })
            .catch(() => {
            this.priceTableLoader = false;
            this.alertContent = 'info';
              this.setAlertDisabled(5000);
              this.$store.dispatch('A_SET_ALERT', 5000);
            });
        }
      } else {
        setTimeout(this.checkPriceTable, 500);
      }
    },
    setDefaultListType() {
      let listType = sessionStorage.getItem("listType") || this.listType;

      const hasHotelOnMap = this.$route.fullPath.includes("hotelOnMap");
      if (hasHotelOnMap) listType = "map";

      if (listType) {
        this.changeListType(listType)
      }
    },
    getFoodTitle(item) {
      return this.usePansionGlobalCode ? item.Name : item.Code + ' - ' + item.Name
    },
    removePrice(price = null) {
      let params = this.$route.fullPath.split("&");
      params = params.map(x => {
        if (!price && (x.includes("minPrice") || x.includes("maxPrice"))) {
          return null
        } else if (price && x.includes("minPrice")) {
          return `minPrice=${price[0]}`
        } else if (price && x.includes("maxPrice")) {
          return `maxPrice=${price[1]}`
        } else {
          return x
        }
      }).filter(x => x);

      params = params.join("&");
      if (this.$route.fullPath !== params)
        this.$router.push(params);

      let key = this.selectedFilters.map(x => x.Type).indexOf("price");
      if (!price && key !== -1) {
        this.$nextTick(() => {
          this.selectedFilters = this.selectedFilters.filter((x, i) => i !== key)
        })
      }
    },
    getCurrencyDisplayBySettings(rate){
      return this.$store.getters['getCurrencyDisplayBySettings'](rate);
    },
    resize() {
      this.setDoneBtnPosition();
      if (!this.$refs.airLineFilter) {
        return
      }

      let padding = window.innerWidth > 1140 ? 60 : 20;
      let space = 10;
      const left = parseInt(this.$refs.airLineFilter.getBoundingClientRect().left) || 0;

      this.$refs.line2.style.right = `calc(100% - ${left - padding - space}px)`;
      this.$refs.line2.style.left = (left - padding - space - 1) + "px";
      this.$refs.line1.style.right = `calc(100% - ${left - padding - space}px)`;
    },
    scroll() {
      this.setDoneBtnPosition();
    },
    correctPrice(val, round = false) {
      if (round) {
        val = Math.round(val);
      }
      const isFloat = val % 1 !== 0;
      let res = new Intl.NumberFormat().format(val);

      if (res.includes(".") || !isFloat) {
        res = res.replace(/,/g, " ");
      } else {
        res = res.replace(/,/g, ".");
      }
      res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
      return res
    },
    maskInputForNumber(event, range) {
      //разрешаем только ввода чисел
      let validNum = event.target.value.replace(/[^0-9]/g, "");
      //проверяем на допустимый диапазон
      if (validNum[0] === '0' && validNum.length > 1) {
          event.target.value = ''
      } else if (range !== 0 && validNum > range) {
          event.target.value = range
      } else {
          event.target.value = validNum
      }

      if (event.target.value !== '') {
        return +event.target.value
      } else {
        return event.target.value
      }

    },
    convertPrice(val) {
      return new Promise((resolve, reject) => {
        const data = {
          keys: [...val],
          price: [...this.availabilityPrice]
        };
        this.$store.dispatch('A_CONVERT_PRICE', data)
          .then(res => {
            resolve(res)
          })
            .catch(() => {
                this.alertContent = 'info';
            this.setAlertDisabled(5000);
            this.$store.dispatch('A_SET_ALERT', 5000);
            reject()
          });
      })
    },
    afterConvertPrice(res) {
      const isTickets = this.$route.fullPath.includes("Individuals/Avia");

      const minPrice = res.data.m_Item1;
      const maxPrice = res.data.m_Item2;

      if (minPrice === 0 && maxPrice === 0) {
        this.selectedFilters = this.selectedFilters.filter(x => x.Type !== 'price');
        this.tourPriceLimit[0] = null;
        this.tourPriceLimit[1] = null;
        this.removeMinMaxPriceOfUrl();
      } else {
        this.availabilityPrice[0] = minPrice > 0 ? Math.ceil(minPrice) : '';
        this.availabilityPrice[1] = maxPrice > 0 ? Math.ceil(maxPrice) : '';
        this.availabilityPrice.splice() //для реактивности Vue
      }

      // Обернул в проверку, т.к. с пустыми commonFiltersForHotels выпадает ошибка при смене валюты в авиабилетах
      if (!this.getWindowSettings.commonFiltersForHotels || this.getWindowSettings.commonFiltersForHotels && this.getShowTourResultList) {
        this.pageLoaderCountStatus++;
        this.sendSecondFilterParams(false);
        this.$store.dispatch("hotels/" + typesHotels.A_RENDER_PRICE_TABLE).then(() => {
          let searchParams = this.$route.params.searchParams;
          if (isTickets) {
            searchParams = this.cashUrl;
          }
          let newUrl = searchParams.split("&").filter(x => !x.includes("currentDate") && !x.includes("currentDuration"));
          this.$nextTick(() => {
            if (isTickets) {
              if (this.cashUrl !== newUrl.join("&")) {
                this.cashUrl = newUrl.join("&")
              }
            } else {
              if (this.$route.params.searchParams !== newUrl.join("&")) {
                this.$router.push(newUrl.join("&"))
              }
            }
          });
          this.setPriceTableData();
          this.setPriceFromTableCities(true);
          this.rate = JSON.parse(localStorage.getItem("Rate")) ? JSON.parse(localStorage.getItem("Rate")) : {};
          this.pageLoaderCountStatus--;
        })
        .catch(() => {
            this.pageLoaderCountStatus--;
            this.alertContent = 'info';
          this.setAlertDisabled(5000);
          this.$store.dispatch('A_SET_ALERT', 5000);
        });
     }
    },
    removeMinMaxPriceOfUrl() {
      this.priceChange = false;
      this.availabilityPrice = [...this.tourPriceLimit];
      this.availabilityPrice.splice();
    },
    getHotelTypeIcons(id) {
      let path = this.$store.getters['getPath'];
      return `${this.$store.getters['getApiOrigin']}${path}/GetImage/GetImage?type=hotelType&id=${id}&width=20&height=20`
    },
    getStars(val) {
      let res = 0;
      let stars = parseInt(val[0]);
      if (typeof stars === "number" && !isNaN(stars)) {
        res = stars
      }
      return res
    },
    getSettings() {
        this.tourSettings = this.$store.getters['getSettings'];
    },
    setPriceTableCities() {
      const data = this.priceTableDataCities;
      this.priceGroup = [];

      data.forEach(x => {
        this.priceGroup.push({
          from: x.DepartureCityKey,
          to: x.ArrivalCityKey,
          price: x.RouteMinimalPrice
        })
      });

      let cityFrom = this.$route.params.searchParams ? this.$route.params.searchParams.split("&").find(x => x.includes("cityFrom")) : null;
      let cityTo = this.$route.params.searchParams ? this.$route.params.searchParams.split("&").find(x => x.includes("cityTo")) : null;

      if ((cityFrom || cityTo) && !this.selectPriceTableCities) {
        if (cityFrom) {
          this.cityFromStatus = +cityFrom.split("=")[1];
        }
        if (cityTo) {
          this.cityToStatus = +cityTo.split("=")[1];
        }
        this.selectPriceTableCities = true;
        this.setPriceFromTableCities(true);
      } else {
        this.setPriceFromTableCities();
      }
    },
    setPriceFromTableCities(sendRequest = false, clientEvent = false) {
      return new Promise(resolve => {
        this.$nextTick(() => {
          this.citiesFrom = [
            {
              label: ["Все"],
              value: -2
            }
          ]
          this.citiesTo = [
            {
              label: ["Все"],
              value: -1
            }
          ]
          const data = this.priceTableDataCities;

          data.forEach(x => {
            let fromValues = this.citiesFrom.map(x2 => x2.value);
            let toValues = this.citiesTo.map(x2 => x2.value);
            let labelFrom = [];
            let labelTo = [];
            let priceFrom = 0;
            let priceTo = 0;
            let fromText = "fromPrice";

            if (this.cityFromStatus === -2 && this.cityToStatus === -1) {
              priceFrom = this.priceGroup.filter(x2 => x2.from === x.DepartureCityKey).map(x2 => x2.price);
              priceTo = this.priceGroup.filter(x2 => x2.to === x.ArrivalCityKey).map(x2 => x2.price);
            } else if (this.cityFromStatus === -2) {
              priceFrom = this.priceGroup.filter(x2 => x2.from === x.DepartureCityKey && x2.to === this.cityToStatus).map(x2 => x2.price);

              priceTo = this.priceGroup.filter(x2 => x2.to === x.ArrivalCityKey).map(x2 => x2.price);
            } else if (this.cityToStatus === -1) {
              priceFrom = this.priceGroup.filter(x2 => x2.from === x.DepartureCityKey).map(x2 => x2.price);

              priceTo = this.priceGroup.filter(x2 => x2.from === this.cityFromStatus && x2.to === x.ArrivalCityKey).map(x2 => x2.price);
            } else {
              priceFrom = this.priceGroup.filter(x2 => x2.to === this.cityToStatus && x2.from === x.DepartureCityKey).map(x2 => x2.price);

              priceTo = this.priceGroup.filter(x2 => x2.from === this.cityFromStatus && x2.to === x.ArrivalCityKey).map(x2 => x2.price);
            }
            priceFrom = Math.min.apply(Math, priceFrom);
            labelFrom = [x.DepartureCityName, fromText, `${priceFrom} ${this.getCurrencyDisplayBySettings(this.rate)}`];

            priceTo = Math.min.apply(Math, priceTo);
            labelTo = [x.ArrivalCityName, fromText, `${this.correctPrice(priceTo)} ${this.getCurrencyDisplayBySettings(this.rate)}`];

            if (!fromValues.includes(x.DepartureCityKey)) {
              this.citiesFrom.push({
                label: labelFrom,
                value: x.DepartureCityKey
              })
            }
            if (!toValues.includes(x.ArrivalCityKey)) {
              this.citiesTo.push({
                label: labelTo,
                value: x.ArrivalCityKey
              })
            }
          });

          if (!sendRequest) {
            return
          }
          if (clientEvent) {
            let newUrl = this.$route.params.searchParams.split("&");
            newUrl = newUrl.filter(x => !x.includes("currentDate=") && !x.includes("currentDuration"));

            if (this.$route.params.searchParams !== newUrl.join("&"))
              this.$router.push(newUrl.join("&"));
          }

          this.pageLoaderCountStatus++;
          this.$store.dispatch("hotels/" + typesHotels.A_CHANGE_PRICE_TABLE_CITY, {
            from: this.cityFromStatus,
            to: this.cityToStatus
          })
            .then(() => {
              this.$nextTick(() => {
                this.changeUrlByPriceTableCity();
                this.pageLoaderCountStatus--;

                resolve()
              })
            })
            .catch(() => {
                this.pageLoaderCountStatus--;
                this.alertContent = 'info';
              this.setAlertDisabled(5000);
              this.$store.dispatch('A_SET_ALERT', 5000);
            });
        })
      })
    },
    setPriceTableData() {
      const dayMode = this.tourSettings ? ((this.tourSettings.TourSearchMode == 1 || this.tourSettings.TourSearchMode == 2) ? "DurationInNight" : "Duration") : "Duration";
      const data = this.priceTableData;
      this.addintionalPriceHeaderAll = [];
      this.addintionalPriceItemsAll = [];
      this.setPriceTableCities();

      let cashPriceItems = [];
      data.forEach(x => {
        //Собираем даты
        if (!this.addintionalPriceHeaderAll.includes(x.StartDate)) {
          this.addintionalPriceHeaderAll.push(x.StartDate)
          this.addintionalPriceHeaderAll.sort();
        }

        //Собираем Продолжительность дней
        if (!cashPriceItems.length) {
          cashPriceItems.push([{
            text: x[dayMode]
          }]);
          this.addintionalPriceItemsAll.push([{
            text: x[dayMode]
          }]);
        } else {
          const includeDuration = cashPriceItems.find(x2 => x2[0].text == x[dayMode]);
          if (!includeDuration) {
            cashPriceItems.push([{
              text: x[dayMode]
            }])

            //Сортируем по продолжительности
            this.addintionalPriceItemsAll = [];
            let isSmall = false;
            let smallDuration = null;

            cashPriceItems.forEach(x2 => {
              if (x2[0].text > x[dayMode] && !isSmall) {
                smallDuration = x[dayMode]
                this.addintionalPriceItemsAll.push([{
                  text: x[dayMode]
                }]);
                this.addintionalPriceItemsAll.push([{
                  text: x2[0].text
                }]);
                isSmall = true;
              } else if (smallDuration != x2[0].text) {
                this.addintionalPriceItemsAll.push([{
                  text: x2[0].text
                }])
              }
            });
            cashPriceItems = this.addintionalPriceItemsAll.slice()
          }
        }
      });

      //Собираем Цены
      data.forEach(x => {
        const columnIndex = this.addintionalPriceHeaderAll.indexOf(x.StartDate);
        this.addintionalPriceItemsAll.forEach((x2, i2) => {
          if (x2[0].text == x[dayMode]) {
            this.addintionalPriceItemsAll[i2][columnIndex + 1] = {
              text: x.Cost,
              value: x.Cost,
              date: x.StartDate,
              duration: x[dayMode]
            }
          }
        })
      });
      //Заполняем пустие цены
      this.addintionalPriceItemsAll = this.addintionalPriceItemsAll.map(x => {
        for (let i = 0; i < x.length; i++) {
          if (!x[i]) {
            x[i] = {
              text: "–",
              isEmpty: true
            }
          }
        }
        const columnLength = this.addintionalPriceHeaderAll.length;
        const itemsLength = x.length - 1;

        if (itemsLength < columnLength) {
          for (let i = 0; i < columnLength - itemsLength; i++) {
            x.push({
              text: "–",
              isEmpty: true
            })
          }
        }
        return x
      })

      this.addintionalPriceHeader = this.addintionalPriceHeaderAll.filter((x, i) => i < 5);
      this.addintionalPriceItems = this.addintionalPriceItemsAll.map(x => x.filter((x2, i) => i < 6));
      //this.addintionalPrice = [0, 1, this.addintionalPriceItemsAll[0][1].value];

      //Определяем сколько колонок должно быть в таблице
      setTimeout(() => {
        this.createPriceTableColumns()
      }, 0)

    },
    createPriceTableColumns() {
      this.createPriceTableColumnsEmitter++
    },
    addintionalPriceSlideRight() {
      let index = this.sliderPosition;
      let item = this.addintionalPriceHeaderAll[index + 5];
      if (item) {
        this.addintionalPriceHeader.push(item);
        this.addintionalPriceHeader.shift();
        this.addintionalPriceItems = this.addintionalPriceItemsAll.map(x => x.filter((x2, i) => i === 0 || i > index + 1 && i < index + 7));

        this.sliderPosition++
      }
    },
    addintionalPriceSlideLeft() {
      const columnCount = this.addintionalPriceHeaderAll.length > 5 ? 5 : this.addintionalPriceHeaderAll.length;
      let index = this.sliderPosition;
      let item = this.addintionalPriceHeaderAll[index - 1];
      if (item) {
        this.addintionalPriceHeader.unshift(item);
        this.addintionalPriceHeader.pop();
        this.addintionalPriceItems = this.addintionalPriceItemsAll.map((x) => {
          x = x.filter((x2, i2) => {
            if (i2 === 0 || i2 >= index && i2 < index + columnCount) {
              return x
            }

          });
          return x
        });

        this.sliderPosition--
      }
    },
    setAddintionalPrice(key1, key2, item) {
      if (key2 !== 0 && !item.isEmpty) {
        this.pageLoaderCountStatus++
        let index = this.sliderPosition;
        if (JSON.stringify(this.addintionalPrice) === JSON.stringify([key1, key2 + index, item.value])) {
          this.addintionalPrice = [];
          this.$store.dispatch("hotels/" + typesHotels.A_SET_PRICE_TABLE, null).then(() => {
            this.filtersChangeStatus = false;
            this.changeUrlByPriceTable(null);
            this.pageLoaderCountStatus--
          })
            .catch(() => {
                this.pageLoaderCountStatus--;
                this.alertContent = 'info';
              this.setAlertDisabled(5000);
              this.$store.dispatch('A_SET_ALERT', 5000);
            });
        } else {
          this.addintionalPrice = [key1, key2 + index, item.value];

          let date = item.date.split("T")[0];
          date = date.split("-").reverse().join(".");
          let duration = item.duration;
          const cityFrom = this.citiesFrom.find(x => x.value === this.cityFromStatus).value;
          const cityTo = this.citiesTo.find(x => x.value === this.cityToStatus).value;
          let sendParams = {
            cityFrom,
            cityTo,
            date,
            duration: (this.tourSettings.TourSearchMode == 1 || this.tourSettings.TourSearchMode == 2) ? duration + 1 : duration
          }
          this.$store.dispatch("hotels/" + typesHotels.A_SET_PRICE_TABLE, sendParams).then(() => {
            this.filtersChangeStatus = false;
            this.pageLoaderCountStatus--;
            this.changeUrlByPriceTable(sendParams)
          })
            .catch(() => {
                this.pageLoaderCountStatus--;
                this.alertContent = 'info';
              this.setAlertDisabled(5000);
              this.$store.dispatch('A_SET_ALERT', 5000);
            });
        }
      }
    },
    checkIsActive(key1, key2, value) {
      let index = this.sliderPosition
      return this.addintionalPrice[0] === key1 && this.addintionalPrice[1] === key2 + index && this.addintionalPrice[2] === value
    },
    sendDateForm(date) {
      let correctDate = date.split("T")[0];
      return correctDate.split("-").reverse().join(".");
    },
    changePriceTableByUrl() {
      let urlParams = this.$route.params.searchParams;
      if (urlParams) {
        urlParams = urlParams.split("&");
        let date = urlParams.find(x => x.includes("currentDate"));
        if (!date || !this.showPriceTable) {
          this.pageLoaderCountStatus--;
          return
        }
        date = date.split("=")[1];

        let duration = urlParams.find(x => x.includes("currentDuration")).split("=")[1];
        duration = (this.tourSettings.TourSearchMode == 1 || this.tourSettings.TourSearchMode == 2) ? duration - 1 : duration
        let key1 = null;
        let key2 = null;
        let cost = null;
        let dateTimeFormat = null;

        this.priceTableReady = true;
        this.addintionalPriceItemsAll.forEach((x, i) => {
          if (x[0].text == duration) {
            key1 = i;

            x.forEach((x2, i2) => {
              if (x2.date && this.sendDateForm(x2.date) == date) {
                key2 = i2;
                cost = x2.value;
                dateTimeFormat = x2.date;
              }
            });
          }
        });
        const sendItem = {
          value: cost,
          date: dateTimeFormat,
          duration
        };
        if (dateTimeFormat)
          this.setAddintionalPrice(key1, key2, sendItem)
      }
    },
    changeUrlByPriceTable(data) {
      let currentUrl = this.$route.params.searchParams;
      if (data) {
        let index = currentUrl.indexOf("&currentDate");
        let newUrl = null;
        if (index !== -1) {
          newUrl = currentUrl.split("&");
          newUrl = new Set(newUrl);
          newUrl = Array.from(newUrl)
            .map(x => {
              if (x.includes("currentDate")) {
                x = `currentDate=${data.date}`
              }
              if (x.includes("currentDuration")) {
                x = `currentDuration=${data.duration}`
              }
              return x
            })
            .join("&");
        } else {
          newUrl = `${currentUrl}&currentDate=${data.date}&currentDuration=${data.duration}`;
        }

        if (this.$route.params.searchParams !== newUrl) {
          this.$router.push(newUrl)
        }
      } else {
        let newUrl = currentUrl.split("&currentDate")[0];

        if (this.$route.params.searchParams !== newUrl)
          this.$router.push(newUrl)
      }
    },
    changeUrlByPriceTableCity() {
      let currentUrl = this.$route.params.searchParams;
      let isTickets = this.$route.fullPath.includes("Individuals/Avia");
      if (isTickets) {
        currentUrl = this.cashUrl;
      }
      let newUrl = currentUrl.split("&");
      const hasCurrentDate = currentUrl.includes("currentDate");

      if (this.cityFromStatus === -2 && this.cityToStatus === -1) {
        newUrl = newUrl.filter(x => !x.includes("cityFrom") && !x.includes("cityTo"));
        newUrl = newUrl.join("&");
      } else if (this.cityFromStatus === -2) {
        newUrl = newUrl.filter(x => !x.includes("cityTo"));
        newUrl = newUrl.join("&");
        newUrl = `${newUrl}&cityTo=${this.cityToStatus}`
      } else if (this.cityToStatus === -1) {
        newUrl = newUrl.filter(x => !x.includes("cityFrom"));
        newUrl = newUrl.join("&");
        newUrl = `${newUrl}&cityFrom=${this.cityFromStatus}`
      } else {
        newUrl = newUrl.filter(x => !x.includes("cityFrom") && !x.includes("cityTo"));
        newUrl = newUrl.join("&");
        newUrl = `${newUrl}&cityFrom=${this.cityFromStatus}&cityTo=${this.cityToStatus}`
      }

      if (hasCurrentDate) {
        let urlLastPart = newUrl.split("&currentDate")[1];
        urlLastPart = `&currentDate${urlLastPart}`;
        newUrl = newUrl + "" + urlLastPart;
      }
      if (isTickets) {
        if (this.cashUrl !== newUrl) {
          this.cashUrl = newUrl
        }
      } else {

        if (this.$route.params.searchParams !== newUrl) {
          this.$router.push(newUrl)
        }
      }
    },
    changeCitiFrom(val) {
      this.cityFromStatus = val;
      this.setPriceFromTableCities(true, true);
    },
    changeCityToStatus(val) {
      this.cityToStatus = val;
    },
    changeFilterType(type, global = false) {
      if (type === this.filterType || global && this.filterType) {
        this.hide();
        this.cashFilterType = "";
        bus.$emit("toggle-up-btn", true)
      } else {
        this.cashFilterType = type;

        if (type === 1 && !this.getWindowSettings.commonFiltersForHotels) {
          this.getPriceTable();
        } 
        // else if (type === 2) {
        //   this.getMaxPrice()
        // }
        this.focus = true;
        this.filterType = type;
        this.$nextTick(() => {
          this.resize();
        });


        if (this.fixedFilters) {
          bus.$emit("toggle-up-btn", false)
        }
      }
    },
    setDoneBtnPosition() {
      const secondSearchBarList = document.querySelector(".second-search-bar-list");
      const btnGroup = document.querySelector(".btn-group");
      if (!btnGroup || !secondSearchBarList)
        return;

      const secondSearchBarListTop = secondSearchBarList.getBoundingClientRect().top;

      const conditionForFixedFilters = secondSearchBarList.clientHeight < secondSearchBarList.scrollHeight;
      const conditionWithoutFixedFilters = secondSearchBarList.scrollHeight > window.innerHeight - secondSearchBarListTop;

      if ((this.fixedFilters && conditionForFixedFilters || !this.fixedFilters && conditionWithoutFixedFilters) && window.innerHeight > 300) {
        btnGroup.classList.add("fixed");

        const largeFilterOpened = this.filterType === 3 || this.filterType === 4 || this.filterType === 5;
        if (largeFilterOpened) {
          secondSearchBarList.style.paddingBottom = "95px";
        }
      } else {
        btnGroup.classList.remove("fixed");
        secondSearchBarList.style.paddingBottom = "20px";
      }
    },
    getPriceTable() {
      if (!this.priceTableReady) {
        this.priceTableLoader = true;
        this.$store.dispatch('hotels/A_GET_PRICE_TABLE', this.priceTableReady)
          .then(() => {
            setTimeout(() => {
              this.createPriceTableColumns();
              this.priceTableReady = true;
              const hasCityTo = this.$route.fullPath.includes("cityTo=");

              if (this.hasOutSystem && !this.priceTableOutSystemReady) {
                this.priceTableLoader = true;
                this.$store.dispatch('hotels/A_GET_PRICE_TABLE_OUT_HOTEL')
                  .then(() => {
                    if (hasCityTo) {
                      this.setPriceFromTableCities(true, false)
                        .then(() => {
                          this.priceTableLoader = false;
                          this.priceTableOutSystemReady = true;
                          this.changePriceTableByUrl();
                        })
                    } else {
                      this.priceTableLoader = false;
                      this.priceTableOutSystemReady = true;
                      this.changePriceTableByUrl();
                    }
                  })
                  .catch(() => {
                      this.priceTableLoader = false;
                      this.alertContent = 'info';
                    this.setAlertDisabled(5000);
                    this.$store.dispatch('A_SET_ALERT', 5000);
                  });
              } else {
                if (hasCityTo) {
                  this.setPriceFromTableCities(true, false)
                    .then(() => {
                      this.priceTableLoader = false;
                      this.changePriceTableByUrl();
                    })
                } else {
                  this.priceTableLoader = false;
                  this.changePriceTableByUrl();
                }
              }
            }, 0)
          })
          .catch(() => {
              this.priceTableLoader = false;
              this.alertContent = 'info';
            this.setAlertDisabled(5000);
            this.$store.dispatch('A_SET_ALERT', 5000);
          });
      } else {
        setTimeout(() => this.createPriceTableColumns(), 0)
      }
    },
    getMaxPrice(resetPrice = false) {
      let maxPriceIsSet = this.$store.getters['hotels/getMaxPriceIsSet'];
      if (maxPriceIsSet) {
        return
      }
      this.priceLoader = true;
      //bus.$emit("page-load", true);

      this.$store.dispatch('hotels/A_GET_MAX_PRICE')
        .then(res => {
          bus.$emit("min-max-price-hotels", {
            price: res.price,
            resetPrice
          });
          if (this.saveCurrency.length && !this.currencyCorrectAfterChange) {
            this.convertPrice(this.saveCurrency)
              .then((res) => {
                this.afterConvertPrice(res);
                this.currencyCorrectAfterChange = true;
                this.priceLoader = false;
                //bus.$emit("page-load", false);
              });
          } else {
            this.priceLoader = false;
            //bus.$emit("page-load", false);
          }
        })
        .catch(() => {
            this.priceLoader = false;
            this.alertContent = 'info';
          this.setAlertDisabled(5000);
          this.$store.dispatch('A_SET_ALERT', 5000);
        });
    },
    resetLocalChanges() {
      this.changeSecondFiltersOfUrl(true);
      this.filtersChangeStatus = false;
      this.hide(true);
      this.pageLoaderCountStatus--;
    },
    changeListType(type) {
      let href = this.$route.fullPath.split("&");
      if (type === "map") {
        if (this.cashHotelOnMap) {
          bus.$emit("map_selected_hotel_for_hotelsTab", +this.cashHotelOnMap)
        }
      } else {
        const hotelOnMap = href.find(x => x.includes("hotelOnMap"));
        if (hotelOnMap) {
          this.cashHotelOnMap = hotelOnMap.split("=")[1];
          bus.$emit("map_selected_hotel_for_hotelsTab", null)
        }
      }

      this.listType = type;
      sessionStorage.setItem("listType", type);
      bus.$emit("changeListType-for-hotels", type);
    },
    setAlertDisabled(time) {
      this.alertDisabled = false;
      setTimeout(() => (this.alertDisabled = true), time)
    },
    hide() {
      this.focus = false;
      this.filterType = ""
    },
    changeSecondFiltersOfUrl(hide = false, ofSelectedFilters = false) {
      this.pageLoaderCountStatus++;
      let urlSearchParams = this.$route.params.searchParams;
      let hasAdditionalParams = urlSearchParams ? (urlSearchParams.split("currency=")[1].includes("&")) : false;

      if (hide) {
        if (!urlSearchParams) {
          this.pageLoaderCountStatus--;
          return new Promise(resolve => resolve(true))
        }
      } else {
        if ((!urlSearchParams || !hasAdditionalParams) && !ofSelectedFilters) {
          this.pageLoaderCountStatus--;
          return new Promise(resolve => resolve(true))
        }
      }

      this.filterChange = [];
      let data = this.$route.params.searchParams.split("&");
      const selectedHotelsOnMap = data.find(x => x.includes("hotelOnMap"));
      if (selectedHotelsOnMap) {
        const hotelsKeys = selectedHotelsOnMap
          .split("=")[1]
          .split(",")
          .map(x => +x);

        this.tourMapHotelList = [];
        this.tourHotelList.forEach(x => {
          if (hotelsKeys.includes(x.Key)) {
            this.tourMapHotelList.push(x)
          }
        });
        this.sendHotelsOnMap = true;
      }

      let program = false;
      let hotelType = false;
      let city = false;
      let resort = false;
      let category = false;
      let food = false;
      let hotel = false;
      let roomFeatures = false;
      let hotelTypeCombination = false;
      let hotelCombination = false;
      let classT = false;
      let classMulty = false;
      let dTransfer = false;
      let aTransfer = false;
      let fTransfer = false;
      let fTransferArrival = false;
      let dAiraport = false;
      let aAiraport = false;
      let airline = false;
      let airlineMulty = false;

      data.forEach(x => {
          if (x.includes("hotelSignCombination")) {
              this.tourHotelTypeCombination = true;
              hotelTypeCombination = true; 
          } else if (!hotelTypeCombination){
              this.tourHotelTypeCombination = false;
          }
          if (x.includes("hotelCombination")) {
              this.tourHotelCombination = true;
              hotelCombination = true; 
          } else if (!hotelCombination){
              this.tourHotelCombination = false;
          }
          if (x.includes("minPrice")) {
            this.priceChange = true;
            this.availabilityPrice = [
              +(x.split("=")[1]),
              this.availabilityPrice[1]
            ]
          }
          const minPriceInclude = data.some(x2 => x2.includes("minPrice"))
          if (!minPriceInclude) {
            this.availabilityPrice = [
              this.tourPriceLimit[0],
              this.availabilityPrice[1]
            ]
          }
          if (x.includes("maxPrice")) {
            this.priceChange = true;
            this.availabilityPrice = [
              this.availabilityPrice[0],
              +(x.split("=")[1])
            ]
          }
          const maxPriceInclude = data.some(x2 => x2.includes("maxPrice"))
          if (!maxPriceInclude) {
            this.availabilityPrice = [
              this.availabilityPrice[0],
              this.tourPriceLimit[1]
            ]
            }
          if (x.includes("hotelQuota")) {
              this.setDefaultFilter(parseInt(x.split("=")[1]), "hotelQuota");
          }
            if (x.includes("aviaQuota")) {
              this.setDefaultFilter(parseInt(x.split("=")[1]), "aviaQuota")
          }
          if (x.includes("busTransferQuota")) {
              this.setDefaultFilter(parseInt(x.split("=")[1]), "busTransferQuota");
          }
          if (x.includes("trainTransferQuota")) {
              this.setDefaultFilter(parseInt(x.split("=")[1]), "trainTransferQuota");
          }
          if (x.includes("tours")) {
            this.tourProgramList.map(x2 => {
              let keys = x.split("=")[1].split(",")
              this.$set(this.tourProgramChecked, x2.Key, keys.includes(x2.Key + ""));
              program = true
            });
          } else if (!program) {
            this.tourProgramList.map(x2 => {
              this.$set(this.tourProgramChecked, x2.Key, false);
            });
          }
          if (x.includes("hotelTypes")) {
            this.tourHotelTypeList.map(x2 => {
              let keys = x.split("=")[1].split(",")
              this.$set(this.tourHotelTypeChecked, x2.key, keys.includes(x2.key + ""));
              hotelType = true
            });
          } else if (!hotelType) {
            this.tourHotelTypeList.map(x2 => {
              this.$set(this.tourHotelTypeChecked, x2.key, false);
            });
          }
          if(x.includes("maskKeys")){
            this.tourRoomFeaturesList.map(x2 => {
              let keys = x.split("=")[1].split(",")
              this.$set(this.tourRoomFeaturesChecked, x2.Key, keys.includes(x2.Key + ""));
              roomFeatures = true
            });
          } else if (!roomFeatures) {
            this.tourRoomFeaturesList.map(x2 => {
              this.$set(this.tourRoomFeaturesChecked, x2.Key, false);
            })
          }
          if (x.includes("cities")) {
            if (this.easySearchFilterForHotels) {
              const hotelsTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));
              let keys = x.split("=")[1].split(",")
              keys.forEach(x2 => {
                if (!hotelsTourToCombo.isCity) {
                  this.$set(this.tourCitiesChecked, x2, false);
                } else {
                  // this.$set(this.tourCitiesChecked, x2, true);
                  this.$set(this.tourCitiesChecked, +hotelsTourToCombo.cityKey, true);
                  city = true
                }
              });
            } else {
              this.tourCitiesList.map(x2 => {
                let keys = x.split("=")[1].split(",")
                this.$set(this.tourCitiesChecked, x2.key, keys.includes(x2.key + ""));
                city = true
              });
            }
          } else if (!city) {
            this.tourCitiesList.map(x2 => {
              this.$set(this.tourCitiesChecked, x2.key, false);
            });
          }
          if (x.includes("resorts")) {
            if (this.easySearchFilterForHotels) {
              const hotelsTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));
              let keys = x.split("=")[1].split(",")
              keys.forEach(x2 => {
                if (!hotelsTourToCombo.isResort) {
                  this.$set(this.tourResortChecked, x2, false);
                } else {
                  // this.$set(this.tourResortChecked, x2, true);
                  this.$set(this.tourResortChecked, +hotelsTourToCombo.resortKey, true);
                  resort = true
                }
              });
            } else {
              this.tourResortList.map(x2 => {
                let keys = x.split("=")[1].split(",")
                this.$set(this.tourResortChecked, x2.Key, keys.includes(x2.Key + ""));
                resort = true
              });
            }
          } else if (!resort) {
            this.tourResortList.map(x2 => {
              this.$set(this.tourResortChecked, x2.Key, false);
            });
          }
          if (x.includes("cats")) {
            this.tourCategoryList.map(x2 => {
              let keys = x.split("=")[1].split(",");

              if (this.useHotelCategoryGlobalCode) {
                let isChecked = false;
                keys.forEach(x3 => {
                  isChecked = isChecked || x2.Key.includes(+x3)
                });

                this.$set(this.tourCategoryChecked, x2.Key, isChecked);
              } else {
                this.$set(this.tourCategoryChecked, x2.Key, keys.includes(x2.Key + ""));
              }
              category = true
            });
          } else if (!category) {
            this.tourCategoryList.map(x2 => {
              this.$set(this.tourCategoryChecked, x2.Key, false);
            });
          }
          if (x.includes("pansions")) {
            this.tourFoodList.map(x2 => {
              let keys = x.split("=")[1].split(",");

              if (this.usePansionGlobalCode) {
                let isChecked = false;
                keys.forEach(x3 => {
                  isChecked = isChecked || x2.Key.includes(+x3)
                });

                this.$set(this.tourFoodChecked, x2.Key, isChecked);
              } else {
                this.$set(this.tourFoodChecked, x2.Key, keys.includes(x2.Key + ""));
              }
              food = true
            });
          } else if (!food) {
            this.tourFoodList.map(x2 => {
              this.$set(this.tourFoodChecked, x2.Key, false);
            });
          }
          if (x.includes("hotels=")) {
            if (this.easySearchFilterForHotels) {
              const hotelsTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));
              let keys = x.split("=")[1].split(",")
              keys.forEach(x2 => {
                if (!hotelsTourToCombo.isHotel) {
                  this.$set(this.tourHotelChecked, x2, false);
                } else {
                  // this.$set(this.tourHotelChecked, x2, true);
                  this.$set(this.tourHotelChecked, +hotelsTourToCombo.hotelKey, true);
                  hotel = true
                }
              });
            } else {
              this.tourHotelList.map(x2 => {
                let keys = x.split("=")[1].split(",")
                this.$set(this.tourHotelChecked, x2.Key, keys.includes(x2.Key + ""));
                hotel = true
              });
            }
          } else if (!hotel) {
            this.tourHotelList.map(x2 => {
              this.$set(this.tourHotelChecked, x2.Key, false);
            });
          }
          if (x.includes("flightTariffs")) {
            // Combo Tariff
            // this.tourClassList.forEach(x2 => {
            //     x2.forEach(x3 => {
            //         let keys = x.split("=")[1].split(",");
            //         this.$set(this.tourClassChecked, x3.Key, keys.includes(x3.Key + ""));
            //         classT = true
            //     });
            // });
            this.tourClassList.map(x2 => {
              let keys = x.split("=")[1].split(",")
              this.$set(this.tourClassChecked, x2.Key, keys.includes(x2.Key + ""));
              classT = true
            });
          } else if (!classT) {
            // Combo Tariff
            // this.tourClassList.forEach(x2 => {
            //     x2.forEach(x3 => {
            //         this.$set(this.tourClassChecked, x3.Key, false);
            //     })
            // });
            this.tourClassList.map(x2 => {
              this.$set(this.tourClassChecked, x2.Key, false);
            });
          }
          if (x.includes("combineTariffs")) {
            this.tourClassMulty.isChecked = true
            classMulty = true
          } else if (!classMulty) {
            this.tourClassMulty.isChecked = false
          }
          if (x.includes("dTransfer")) {
            this.tourTransplantationList[0].isChecked = true
            dTransfer = true
          } else if (!dTransfer) {
            this.tourTransplantationList[0].isChecked = false
          }
          if (x.includes("aTransfer")) {
            this.tourTransplantationListTo[0].isChecked = true
            aTransfer = true
          } else if (!aTransfer) {
            this.tourTransplantationListTo[0].isChecked = false
          }
          if (x.includes("departureFlightNumberTransfer")) {
            let numb = x.split("=")[1];
            this.tourTransplantationList[1].isChecked = numb == 1 || numb == 3;
            this.tourTransplantationList[2].isChecked = numb == 2 || numb == 3;
            fTransfer = true
          } else if (!fTransfer) {
            this.tourTransplantationList[1].isChecked = false;
            this.tourTransplantationList[2].isChecked = false;
          }
          if (x.includes("arrivalFlightNumberTransfer")) {
            let numb = x.split("=")[1];
            this.tourTransplantationListTo[1].isChecked = numb == 1 || numb == 3;
            this.tourTransplantationListTo[2].isChecked = numb == 2 || numb == 3;
            fTransferArrival = true
          } else if (!fTransferArrival) {
            this.tourTransplantationListTo[1].isChecked = false;
            this.tourTransplantationListTo[2].isChecked = false;
          }
          if (x.includes("dep_airports")) {
            this.tourDepartureList.map(x2 => {
              let keys = x.split("=")[1].split(",")
              this.$set(this.tourDepartureAirportsChecked, x2.Key, keys.includes(x2.Code));
              dAiraport = true
            });
          } else if (!dAiraport) {
            this.tourDepartureList.map(x2 => {
              this.$set(this.tourDepartureAirportsChecked, x2.Key, false);
            });
          }
          if (x.includes("arr_airports")) {
            this.tourArrivalList.map(x2 => {
              let keys = x.split("=")[1].split(",")
              this.$set(this.tourArrivalAirportsChecked, x2.Key, keys.includes(x2.Code));
              aAiraport = true
            });
          } else if (!aAiraport) {
            this.tourArrivalList.map(x2 => {
              this.$set(this.tourArrivalAirportsChecked, x2.Key, false);
            });
          }
          if (x.includes("airlines")) {
            this.tourAirlineList.map(x2 => {
              let keys = x.split("=")[1].split(",")
              this.$set(this.tourAirlinesChecked, x2.Key, keys.includes(x2.Code));
              airline = true
            });
          } else if (!airline) {
            this.tourAirlineList.map(x2 => {
              this.$set(this.tourAirlinesChecked, x2.Key, false);
            });
          }
          if (x.includes("combineAirlines")) {
            this.tourAirlineMulty.isChecked = true
            airlineMulty = true
          } else if (!airlineMulty) {
            this.tourAirlineMulty.isChecked = false
          }
          if (x.includes("depTimeFrom")) {
            let time = x.split("=")[1];
            this.departureTime = [
              this.timeToMinuts(time),
              +this.departureTime[1]
            ];
            this.dTimeChange = true;
          }
          const depTimeFromInclude = data.some(x2 => x2.includes("depTimeFrom"));
          if (!depTimeFromInclude) {
            this.departureTime = [
              0,
              this.departureTime[1]
            ]
          }
          if (x.includes("depTimeTo")) {
            let time = x.split("=")[1];
            this.departureTime = [
              +this.departureTime[0],
              this.timeToMinuts(time)
            ];
            this.dTimeChange = true;
          }
          const depTimeToInclude = data.some(x2 => x2.includes("depTimeTo"));
          if (!depTimeToInclude) {
            this.departureTime = [
              this.departureTime[0],
              1439
            ]
          }
          if (x.includes("arrTimeFrom")) {
            let time = x.split("=")[1];
            this.arrivalTime = [
              this.timeToMinuts(time),
              +this.arrivalTime[1]
            ];
            this.aTimeChange = true;
          }
          const arrTimeFromInclude = data.some(x2 => x2.includes("arrTimeFrom"));
          if (!arrTimeFromInclude) {
            this.arrivalTime = [
              0,
              this.arrivalTime[1]
            ]
          }
          if (x.includes("arrTimeTo")) {
            let time = x.split("=")[1];
            this.arrivalTime = [
              +this.arrivalTime[0],
              this.timeToMinuts(time)
            ];
            this.aTimeChange = true;
          }
          const arrTimeToInclude = data.some(x2 => x2.includes("arrTimeTo"));
          if (!arrTimeToInclude) {
            this.arrivalTime = [
              this.arrivalTime[0],
              1439
            ]
          }

        });

      // Флаг для однократного вызова функции (при перезагрузке)
      this.$store.commit("hotels/" + mTypesHotels.M_SET_ON_MOUNTED_CHANGE_DAYS_FLAG, true)

      let changeParams = {
        price: this.availabilityPrice,
        classMulty: this.tourClassMulty.isChecked,
        airlinesMulty: false,
        dTime: [
          this.minutsToTime(this.departureTime[0]),
          this.minutsToTime(this.departureTime[1])
        ],
        aTime: [
          this.minutsToTime(this.arrivalTime[0]),
          this.minutsToTime(this.arrivalTime[1])
        ],
      };

      return new Promise((resolve) => {

        this.changeSecondFilter("changeAll", null, changeParams, true).then(() => {
          if (!hide) {
            this.sendSecondFilterParams(false).then(() => {

              this.pageLoaderCountStatus--;
              resolve(true)
            });
          } else {
            this.pageLoaderCountStatus--;
            this.filtersChangeStatus = false
          }
        })
      });
    },
    togglePriceTable(val) {
      this.changeFilterType(val ? 1 : -1);
      this.showPriceTableForLeftFilters = val;

      const tourResult = document.querySelector(".hotels-result");
      const leftFilters = document.querySelector(".hotels-second-search-bar-left");
      const tourResultContent = document.querySelector(".hotels-result-content");
      tourResultContent.style.marginLeft = val ? leftFilters.clientWidth + 60 + "px" : "unset";
      tourResult.style.minHeight = val ? leftFilters.clientHeight + leftFilters.offsetTop * 2 + "px" : "unset";
      tourResult.style.display = val ? "block" : "";
      this.statePriceTable = val;
    },
    clearAllFilters(apply = false, clientClick = false) {
      this.filterChange = [];
      this.selectedFilters = [];

      this.availabilityPrice = [...this.tourPriceLimit];
      this.priceChange = false;
      this.tourHotelTypeCombination = false;
      this.tourHotelCombination = false;
      this.tourProgramList = this.tourProgramList.map(x => {
        this.$set(this.tourProgramChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourCategoryList = this.tourCategoryList.map(x => {
        this.$set(this.tourCategoryChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourFoodList = this.tourFoodList.map(x => {
        this.$set(this.tourFoodChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourHotelTypeList = this.tourHotelTypeList.map(x => {
        this.$set(this.tourHotelTypeChecked, x.key, false);
        x.isDisabled = false;
        return x
      });
      this.tourCitiesList = this.tourCitiesList.map(x => {
        this.$set(this.tourCitiesChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourResortList = this.tourResortList.map(x => {
        this.$set(this.tourResortChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourHotelList = this.tourHotelList.map(x => {
        this.$set(this.tourHotelChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourRoomFeaturesList = this.tourRoomFeaturesList.map(x => {
        this.$set(this.tourRoomFeaturesChecked, x.Key, false);
        x.isDisabled = false;
        return x
      })
      this.tourClassList = this.tourClassList.map(x => {
        // Combo Tariff
        // return x.map(x2 => {
        //     this.$set(this.tourClassChecked, x2.Key, false);
        //     x2.isDisabled = false;
        //     return x2
        // });
        this.$set(this.tourClassChecked, x.Key, false);
        x.isDisabled = false;
        return x

      });
      this.tourClassMulty.isChecked = false;
      this.tourTransplantationList = this.tourTransplantationList.map(x => {
        x.isChecked = false;
        x.isDisabled = false;
        return x
      });
      this.tourTransplantationListTo = this.tourTransplantationListTo.map(x => {
        x.isChecked = false;
        x.isDisabled = false;
        return x
      });
      this.tourDepartureList = this.tourDepartureList.map(x => {
        this.$set(this.tourDepartureAirportsChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourArrivalList = this.tourArrivalList.map(x => {
        this.$set(this.tourArrivalAirportsChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourAirlineList = this.tourAirlineList.map(x => {
        this.$set(this.tourAirlinesChecked, x.Key, false);
        x.isDisabled = false;
        return x
      });
      this.tourAirlineMulty.isChecked = false;
      this.departureTime = [0, 1439];
      this.arrivalTime = [0, 1439];
      this.dTimeChange = false;
      this.aTimeChange = false;
      this.localSecondFilters = {
        price: [],
        tourProgram: [],
        tourCities: [],
        tourResort: [],
        tourCategory: [],
        tourHotel: [],
        tourFood: [],
        tourHotelType: [],
        tourClass: [],
        tourClassMulty: false,
        tourTransplantation: [],
        tourDepartureAirports: [],
        tourArrivalAirports: [],
        tourAirlines: [],
        roomFeatures: [],
        tourAirlinesMulty: false,
        departureTime: ["00:00", "23:59"],
        arrivalTime: ["00:00", "23:59"],
      };

      if (this.getSearchSecondParamsCounter === 0 && this.getMainSearchCount <= 1) {
        this.$store.commit("hotels/" + mTypesHotels.M_SET_FIRST_SEARCH, true)
      } else {
        this.$store.commit("hotels/" + mTypesHotels.M_SET_FIRST_SEARCH, false)
      }

      if (clientClick) {
        this.clearAllSearchInput()
        this.showSelectedHotels = false;
      }

      if (apply && this.$route.params.searchParams) {
        this.sendSecondFilterParams(false);
        this.setTopSpace();
      }
    },
    async setTopSpace() {
      await this.$nextTick();

      const verticalFiltersMode = document.querySelector(".vertical-filters-mode");
      if (!verticalFiltersMode) return;

      let height = 0;
      verticalFiltersMode.style.paddingTop = `${height}px`;
    },
      sendSecondFilterParams(hide = true, collapse = false) {
      if (!this.getWindowSettings.commonFiltersForHotels) this.priceLoader = true;
      this.loaderStatus = true;
      this.filtersChangeStatus = false;
      let tourProgram = this.tourProgramList.filter((x) => {
        if (this.tourProgramChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "TourProgram"};
            this.selectedFilters.push(item);
          }
          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "TourProgram" || this.tourProgramChecked[x2.Key]){
              return x2
            }
          })
        }
      });

      if (this.availabilityPrice[0] > this.availabilityPrice[1] && this.availabilityPrice[1]) {
          this.availabilityPrice[0] = this.availabilityPrice[1];
      }

      let minPrice = this.priceChange ? this.availabilityPrice[0] : null;
      let maxPrice = this.priceChange ? this.availabilityPrice[1] : null;
      const rate = JSON.parse(localStorage.getItem('Rate'));
      if (this.priceChange) {
        const [min, max] = this.availabilityPrice;
        let validName = ''
        if (min && max) {
          validName = `${this.localizeList.priceUpper}: ${this.localizeList.from} ${this.correctPrice(min, true)} ${this.getCurrencyDisplayBySettings(rate)} ${this.localizeList.to} ${this.correctPrice(max, true)} ${this.getCurrencyDisplayBySettings(rate)}`
        } else if (min && !max) {
          validName = `${this.localizeList.priceUpper}: ${this.localizeList.from} ${this.correctPrice(min, true)} ${this.getCurrencyDisplayBySettings(rate)}`
        } else if  (!min && max) {
          validName = `${this.localizeList.priceUpper}: ${this.localizeList.to} ${this.correctPrice(max, true)} ${this.getCurrencyDisplayBySettings(rate)}`
        }
        const price = {
          Type: "price",
          Name: validName,
          items: this.availabilityPrice
        };
        let key = this.selectedFilters.map(x => x.Type).indexOf(price.Type);
        if (key === -1 && price.Name) {
          this.selectedFilters.push(price)
        } else if (key !== -1 && !price.Name) {
          this.selectedFilters.splice(key, 1)
        } else {
          this.selectedFilters = this.selectedFilters.map((x, i) => {
            if (key === i) {
              return price
            }
            return x
          })
        }
      }

      let tourCities = this.tourCitiesList.filter((x) => {
        if (this.tourCitiesChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "City"};
            this.selectedFilters.push(item);
          }
          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "City" || this.tourCitiesChecked[x2.Key]){
              return x2
            }
          })
        }
      });

      let tourResort = this.tourResortList.filter((x) => {
        if (this.tourResortChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "Resort"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "Resort" || this.tourResortChecked[x2.Key]){
              return x2
            }
          })
        }
      });
      let tourCategory = this.tourCategoryList.filter((x) => {
        if (this.tourCategoryChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "HotelCategory"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "HotelCategory" || this.tourCategoryChecked[x2.Key]){
              return x2
            }
          })
        }
      });


      let tourFood = this.tourFoodList.filter((x) => {
        if (this.tourFoodChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "Pansion"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "Pansion" || this.tourFoodChecked[x2.Key]){
              return x2
            }
          })
        }
      });
      let tourHotelType = this.tourHotelTypeList.filter((x) => {
        if (this.tourHotelTypeChecked[x.key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "HotelType"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "HotelType" || this.tourHotelTypeChecked[x2.key]){
              return x2
            }
          })
        }
      });
      let roomFeatures = this.tourRoomFeaturesList.filter((x) => {
        if (this.tourRoomFeaturesChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "RoomFeatures"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "RoomFeatures" || this.tourRoomFeaturesChecked[x2.Key]){
              return x2
            }
          })
        }
      });
      let tourHotel = this.tourHotelList.filter((x) => {
        if (this.tourHotelChecked[x.Key]) {
          let item = {...x, Type: "Hotel"};
          this.selectedFilters.push(item);

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "Hotel" || this.tourHotelChecked[x2.Key]){
              return x2
            }
          })
        }
      });

      if (this.easySearchFilterForHotels) {
          const hasHotel = this.$route.params.searchParams.includes("hotels=");
          const hasResort = this.$route.params.searchParams.includes("resorts=");
          const hasCity = this.$route.params.searchParams.includes("cities=");
          const hotelsTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));

          Object.entries(this.tourHotelChecked)
              .filter(x => x[0] && x[1])
              .forEach(x => {
                  if (tourHotel.some(x2 => x2.Key == x[0]) || !hasHotel) return;
                  tourHotel.push({ Key: x[0] })
              });

          Object.entries(this.tourResortChecked)
              .filter(x => x[0] && x[1])
              .forEach(x => {
                  if (tourResort.some(x2 => x2.Key == x[0]) || !hasResort) return;
                  tourResort.push({ Key: x[0] })
              });

          Object.entries(this.tourCitiesChecked)
              .filter(x => x[0] && x[1])
              .forEach(x => {
                  if (tourCities.some(x2 => x2.Key == x[0]) || !hasCity) return;
                  tourCities.push({ Key: x[0] })
              });

          if (hotelsTourToCombo.isHotel) {
              tourHotel = tourHotel.filter(x => +x.Key === +hotelsTourToCombo.hotelKey)
              this.selectedFilters = this.selectedFilters.filter(x => {
                  return x.Type !== "Hotel" || +x.Key === +hotelsTourToCombo.hotelKey
              })
          } else if (hotelsTourToCombo.isResort) {
              tourResort = tourResort.filter(x => +x.Key === +hotelsTourToCombo.resortKey)
              this.selectedFilters = this.selectedFilters.filter(x => {
                  return x.Type !== "Resort" || +x.Key === +hotelsTourToCombo.resortKey
              })
          } else if (hotelsTourToCombo.isCity && hotelsTourToCombo.cityKey !== -1) {
              tourCities = tourCities.filter(x => +x.Key === +hotelsTourToCombo.cityKey)
              this.selectedFilters = this.selectedFilters.filter(x => {
                  return x.Type !== "City" || +x.Key === +hotelsTourToCombo.cityKey
              })
          }
      }

      let tourMapHotel = [];
      if (this.sendHotelsOnMap) {
        this.sendHotelsOnMap = false;
        tourMapHotel = this.tourMapHotelList;
      }
      let tourClass = this.tourClassList.filter((x) => {
        if (this.tourClassChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "AirService"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "AirService" || this.tourClassChecked[x2.Key]){
              return x2
            }
          })
        }
      });
      let tourClassMulty = this.tourClassMulty.isChecked;
      let tourTransplantation = this.tourTransplantationList.filter((x, i) => {
        if (this.tourTransplantationList[i].isChecked) {
          const item = {...x};
          item.Type = `Transplantation_${i}`;
          item.Name = this.localizeList[item.label] +" "+ this.localizeList.forward.toLowerCase();
          if (!this.selectedFilters.map(x => x.Name).includes(item.Name))
            this.selectedFilters.push(item);
          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== `Transplantation_${i}` || this.tourTransplantationList[i].isChecked){
              return x2
            }
          })
        }
      });
      let tourTransplantationArrival;
        // При вертикальных фильтрах мы объединяем логику "Обратно" к "Туда"
        if (this.settings.FiltersDisplayOptions) {
          tourTransplantationArrival = this.tourTransplantationList.filter((x, i) => {
            if (this.tourTransplantationList[i].isChecked) {
              const item = {...x};
              item.Type = `Transplantation_${i}_a`;
              item.Name = this.localizeList[item.label] +" "+ this.localizeList.backward.toLowerCase();
              if (!this.selectedFilters.map(x => x.Name).includes(item.Name))
                this.selectedFilters.push(item);
              return x
            } else {
              this.selectedFilters = this.selectedFilters.filter(x2 => {
                if (x2.Type !== `Transplantation_${i}_a` || this.tourTransplantationList[i].isChecked) {
                  return x2
                }
              })
            }
          });
      } else {
         tourTransplantationArrival = this.tourTransplantationListTo.filter((x, i) => {
          if (this.tourTransplantationListTo[i].isChecked) {
            const item = {...x};
            item.Type = `Transplantation_${i}_a`;
            item.Name = this.localizeList[item.label] +" "+ this.localizeList.backward.toLowerCase();
            if (!this.selectedFilters.map(x => x.Type).includes(item.Type))
              this.selectedFilters.push(item);
            return x
          } else {
            this.selectedFilters = this.selectedFilters.filter(x2 => {
              if (x2.Type !== `Transplantation_${i}_a` || this.tourTransplantationListTo[i].isChecked){
                return x2
              }
            })
          }
        });
      }
      let tourDepartureAirports = this.tourDepartureList.filter((x) => {
        if (this.tourDepartureAirportsChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "Airport"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "Airport" || this.tourDepartureAirportsChecked[x2.Key]){
              return x2
            }
          })
        }
      });
      let tourArrivalAirports = this.tourArrivalList.filter((x) => {
        if (this.tourArrivalAirportsChecked[x.Key]) {
          x = {...x};
          x.Type = "aAirport";
          if (!this.selectedFilters.map(x => x.Name).includes(x.Name))
            this.selectedFilters.push(x);
          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "aAirport" || this.tourArrivalAirportsChecked[x2.Key]){
              return x2
            }
          })
        }
      });
      let tourAirlines = this.tourAirlineList.filter((x) => {
        if (this.tourAirlinesChecked[x.Key]) {
          if (!this.selectedFilters.includes(x)){
            let item = {...x, Type: "AirLine"};
            this.selectedFilters.push(item);
          }

          return x
        } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
            if (x2.Type !== "AirLine" || this.tourAirlinesChecked[x2.Key]){
              return x2
            }
          })
        }
      });
      let tourAirlineMulty = this.tourAirlineMulty.isChecked
      let departureTime = [];
      if (this.dTimeChange) {
        departureTime = [
          this.minutsToTime(this.departureTime[0]),
          this.minutsToTime(this.departureTime[1])
        ];
        const time = {
          Type: "dTime",
          Name: `${this.localizeList.departureUpper} ${this.minutsToTime(this.departureTime[0])} – ${this.minutsToTime(this.departureTime[1])}`,
          items: this.departureTime
        };
        let key = this.selectedFilters.map(x => x.Type).indexOf(time.Type);
        if (key === -1) {
          this.selectedFilters.push(time);
        } else {
          this.selectedFilters = this.selectedFilters.map((x, i) => {
            if (key === i) {
              return time
            }
            return x
          })
        }
      }
      let arrivalTime = [];
      if (this.aTimeChange) {
        arrivalTime = [
          this.minutsToTime(this.arrivalTime[0]),
          this.minutsToTime(this.arrivalTime[1])
        ];
        const time = {
          Type: "aTime",
          Name: `${this.localizeList.arrivalUpper} ${this.minutsToTime(this.arrivalTime[0])} – ${this.minutsToTime(this.arrivalTime[1])}`,
          items: this.arrivalTime
        };
        let key = this.selectedFilters.map(x => x.Type).indexOf(time.Type);
        if (key === -1) {
          this.selectedFilters.push(time);
        } else {
          this.selectedFilters = this.selectedFilters.map((x, i) => {
            if (key === i) {
              return time
            }
            return x
          })
        }
      }

      const railwayTransferQuota = this.getFilterParams.railwayTransferQuota;
      const busTransferQuota = this.getFilterParams.busTransferQuota;
      const aviaQuota = this.getFilterParams.aviaQuota;
      const hotelQuota = this.getFilterParams.hotelQuota;

      let tourHotelTypeCombination = this.tourHotelTypeCombination;
      if (this.tourHotelTypeCombination) {
          const item = {
              Type: "HotelTypeCombination",
              Name: this.localizeList.hotelTypeCombinationUpper,
          }
          this.selectedFilters.push(item);
      } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
              if (x2.Type !== "HotelTypeCombination") {
                  return x2
              }
          })
      }

      let tourHotelCombination = this.tourHotelCombination;
      if (this.tourHotelCombination) {
          const item = {
              Type: "HotelCombination",
              Name: this.localizeList.hotelCombinationUpper,
          };
          this.selectedFilters.push(item);
      } else {
          this.selectedFilters = this.selectedFilters.filter(x2 => {
              if (x2.Type !== "HotelCombination") {
                  return x2
              }
          })
      }

      // Костыли для пробной версии доработок логики для открытых фильтров
      if (this.selectedFilters.length && this.selectedFilters.every(x => x.Type === "HotelCategory") && this.getSearchSecondParamsCounter) {
        this.selectedFilters = [];
        this.filterChange = this.filterChange.filter(x => x !== "tourCategory");
        this.tourCategoryChecked = Object.fromEntries(Object.keys(this.tourCategoryChecked).map(key => [key, false]));
        this.localSecondFilters.tourCategory = this.tourCategoryList.filter((x) => {
          if (this.tourCategoryChecked[x.Key]) {
            return x
          }
        })
        tourCategory = [];
      }
      // Костыли для пробной версии доработок логики для открытых фильтров
      if (this.selectedFilters.length && this.selectedFilters.every(x => x.Type === "Hotel") && this.getSearchSecondParamsCounter) {
        this.filterChange = this.filterChange.filter(x => x !== "tourHotel");
        this.selectedFilters = [];
        this.tourHotelChecked = Object.fromEntries(Object.keys(this.tourHotelChecked).map(key => [key, false]));
        this.localSecondFilters.tourHotel = this.tourHotelList.filter((x) => {
          if (this.tourHotelChecked[x.Key]) {
            return x
          }
        })
        tourHotel = [];
      }
      // Костыли для пробной версии доработок логики для открытых фильтров
      if (this.getWindowSettings.commonFiltersForHotels && Object.values(this.tourCitiesChecked).some(x => x)) {
        const cashHotelList = this.cashSecondFilters.Hotels
        const cities = Object.entries(this.tourCitiesChecked).filter(x => x[1] === true).map(x => +x[0]) || [];
        let categoryKeys = cashHotelList.filter(x => cities.includes(x.City?.Key)).map(x => x.Category?.Key);
        categoryKeys = [...new Set(categoryKeys)];

        tourCategory = tourCategory.filter(x => {
          if (this.useHotelCategoryGlobalCode) {
            return categoryKeys.some(x2 => x.Key.includes(x2))
          } else {
            return categoryKeys.includes(x.Key)
          }
        })
      } else if (this.getWindowSettings.commonFilters && Object.values(this.tourResortChecked).some(x => x)) {
        const cashHotelList = this.cashSecondFilters.Hotels
        const resorts = Object.entries(this.tourResortChecked).filter(x => x[1] === true).map(x => +x[0]) || [];
        let categoryKeys = cashHotelList.filter(x => resorts.includes(x.Resort?.Key)).map(x => x.Category?.Key);
        categoryKeys = [...new Set(categoryKeys)];

        tourCategory = tourCategory.filter(x => {
          if (this.useHotelCategoryGlobalCode) {
            return categoryKeys.some(x2 => x.Key.includes(x2))
          } else {
            return categoryKeys.includes(x.Key)
          }
        })
      }

      const isTickets = this.$route.fullPath.includes("Individuals/Avia");
      let url = this.$route.params.searchParams;
      
      if (isTickets) {
        url = this.cashUrl
      }

      let params = url.split("&");
      let currentDate = null;
      let currentDuration = null;
      params.forEach(x => {
        if (x.includes("currentDate")) {
          currentDate = x.split("=")[1];
        }
        if (x.includes("currentDuration")) {
          currentDuration = x.split("=")[1]
        }
      })

      return new Promise((resolve) => {
        const sendParams = {
          currentDate,
          currentDuration,
          tourProgram,
          minPrice,
          maxPrice,
          tourCities,
          tourResort,
          tourCategory,
          tourFood,
          tourHotelType,
          roomFeatures,
          tourHotelCombination,
          tourHotelTypeCombination,
          tourHotel,
          tourMapHotel,
          tourClass,
          tourClassMulty,
          tourTransplantation,
          tourTransplantationArrival,
          tourDepartureAirports,
          tourArrivalAirports,
          tourAirlines,
          tourAirlineMulty,
          departureTime,
          arrivalTime,
          hotelQuota,
          aviaQuota,
          busTransferQuota,
          railwayTransferQuota,
        };
        bus.$emit("hotels_collapse", collapse);

        if (this.cashSendSecondParams === JSON.stringify(sendParams)) {
          resolve(true);
          return
        }

        bus.$emit("hotels_second_filters_start_search");

        this.cashSendSecondParams = JSON.stringify(sendParams);
        this.$store.dispatch("hotels/" + typesHotels.A_SET_SEARCH_SECOND_PARAMS, sendParams).then(res => {

          if(this.hasOutSystem)
          {
            this.setSecondFilterHotels();
          }

          this.$nextTick(() => {
            if (this.showSelectedHotels) {
              this.filterHotelsBySelected(true); // Если true то в списке отелей показываем только выбранные
            } else {
              this.checkInputFilterValue(); // Обновляем данные в инпутах контекстного поиска
            }
          })

          let params = this.$route.params.searchParams;
          let isTickets = this.$route.fullPath.includes("Individuals/Avia");
          if (isTickets)
            params = this.cashUrl;
            
          const index = params.indexOf("&currentDate");
          const index2 = params.indexOf("&cityFrom") !== -1 ? params.indexOf("&cityFrom") : params.indexOf("&cityTo");
          if (index2 !== -1) {
            let priceTableParams = params.slice(index2);
            if (index !== -1 && index < index2) {
              priceTableParams = params.slice(index);
            }
            if (isTickets) {
              if (params !== res + "" + priceTableParams)
                this.cashUrl = res + "" + priceTableParams
            } else {

              if (params !== res + "" + priceTableParams){
                this.$router.push(res + "" + priceTableParams);
              }
            }
          } else if (index !== -1) {
            let priceTableParams = params.slice(index);
            if (isTickets) {
              if (params !== res + "" + priceTableParams)
                this.cashUrl = res + "" + priceTableParams
            } else {

              if (params !== res + "" + priceTableParams){
                this.$router.push(res + "" + priceTableParams);
              }
            }
          } else {
            if (isTickets) {
              if (params !== res){
                this.cashUrl = res
              }
            } else {

              if (params !== res){
                this.$router.push(res);
              }
            }
          }

          // this.clearAllSearchInput()

          this.priceLoader = false;
          this.loaderStatus = false;
          if (hide) {
            this.hide()
          }
          this.removeSelectedFiltersOfUrl()
          bus.$emit("hotels_second_filters_loaded");
           // Флаг для однократного вызова функции (при перезагрузке)
          this.$store.commit("hotels/" + mTypesHotels.M_SET_ON_MOUNTED_CHANGE_DAYS_FLAG, true)
          resolve(true)
        })
          .catch(() => {
            this.priceLoader = false;
            this.loaderStatus = false;
              bus.$emit("hotels_second_filters_loaded");
              this.alertContent = 'info';
            this.setAlertDisabled(5000);
            this.$store.dispatch('A_SET_ALERT', 5000);
          });
      })
    },
    removeSelectedFiltersOfUrl() {
      const params = this.$route.params.searchParams
      this.selectedFilters = this.selectedFilters.filter(x => {
        return (
          x.Type === "Resort" && params.indexOf("&resorts") !== -1 ||
          x.Type === "City" && params.indexOf("&cities") !== -1 ||
          x.Type === "Hotel" && params.indexOf("&hotels") !== -1 ||
          x.Type !== "Resort" && x.Type !== "City" && x.Type !== "Hotel"
        )
      })
    },
    disabledSecondFilters() {
      let data = this.$store.getters['hotels/getSecondaryFiltersResult'];
      if(!Object.keys(data).length) {
        return;
      }

      if (!this.filterChange.includes("tourProgram")) {
        this.tourProgramList = this.tourProgramList.map((x) => {
          let isIncludes = data.TourPrograms.map(x2 => x2.Key).includes(x.Key)
          if (!isIncludes && !this.tourProgramChecked[x.Key]) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }

      if (!this.filterChange.includes("tourCities")) {
        this.tourCitiesList = this.tourCitiesList.map((x) => {
          let isIncludes = data.HotelCities.map(x2 => x2.key).includes(x.key)
          if (!isIncludes && !this.tourCitiesChecked[x.Key]) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }

      if (!this.filterChange.includes("tourResort")) {
        this.tourResortList = this.tourResortList.map((x) => {
          let isIncludes = data.HotelResorts.map(x2 => x2.Key).includes(x.Key)
          if (!isIncludes && !this.tourResortChecked[x.Key]) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }

      if (!this.filterChange.includes("tourCategory")) {
        this.tourCategoryList = this.tourCategoryList.map((x) => {
          let category = JSON.parse(JSON.stringify(data.HotelCategories));
          if (this.useHotelCategoryGlobalCode) {
            const categoryKeys = category.map(x2 => x2.Key);
            let isIncludes = false;
            categoryKeys.forEach(x2 => {
              isIncludes = isIncludes || x.Key.includes(x2)
            });

            x.isDisabled = !isIncludes && !this.tourCategoryChecked[x.Key]
          } else {
            let isIncludes = category.map(x2 => x2.Key).includes(x.Key);
            x.isDisabled = !isIncludes && !this.tourCategoryChecked[x.Key]
          }
          return x
        });
      } else if (this.getWindowSettings.commonFiltersForHotels) {
        // Пробная версия доработок логики для открытых фильтров
        const cashHotelList = this.cashSecondFilters.Hotels
        const cities = Object.entries(this.tourCitiesChecked).filter(x => x[1] === true).map(x => +x[0]) || [];
        const resorts = Object.entries(this.tourResortChecked).filter(x => x[1] === true).map(x => +x[0]) || [];
        let categoryKeys = cashHotelList.filter(x => cities.includes(x.City?.Key) || resorts.includes(x.Resort?.Key)).map(x => x.Category?.Key);
        categoryKeys = [...new Set(categoryKeys)];

        this.tourCategoryList = this.tourCategoryList.map((x) => {
          if (this.useHotelCategoryGlobalCode) {
            let isIncludes = false;
            if (categoryKeys.length) {
              categoryKeys.forEach(x2 => {
                isIncludes = isIncludes || x.Key.includes(x2)
              });
            } else {
              isIncludes = true
            }

            if (this.tourCategoryChecked[x.Key] && categoryKeys.length && !categoryKeys.some(x2 => x.Key.includes(x2))) {
              this.tourCategoryChecked[x.Key] = false
            }

            x.isDisabled = !isIncludes
          } else {
            let isIncludes = categoryKeys.length ? categoryKeys.includes(x.Key) : true;
            x.isDisabled = !isIncludes

            if (this.tourCategoryChecked[x.Key] && categoryKeys.length && !categoryKeys.some(x2 => x2 === x.Key)) {
               this.tourCategoryChecked[x.Key] = false
            }
          }

          return x
        });
      }

      if (!this.filterChange.includes("tourFood")) {
        this.tourFoodList = this.tourFoodList.map((x) => {
          let pansions = JSON.parse(JSON.stringify(data.Pansions));
          if (this.usePansionGlobalCode) {
            const pansionsKeys = pansions.map(x2 => x2.Key);
            let isIncludes = false;
            pansionsKeys.forEach(x2 => {
              isIncludes = isIncludes || x.Key.includes(x2)
            });

            x.isDisabled = !isIncludes && !this.tourFoodChecked[x.Key]
          } else {
            let isIncludes = pansions.map(x2 => x2.Key).includes(x.Key);
            x.isDisabled = !isIncludes && !this.tourFoodChecked[x.Key]
          }
          return x
        });
      }

      if (!this.filterChange.includes("tourHotelType")) {
        this.tourHotelTypeList = this.tourHotelTypeList.map((x) => {
          let isIncludes = data.HotelTypes.map(x2 => x2.key).includes(x.key)
          if (!isIncludes && !this.tourHotelTypeChecked[x.key]) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }
      if(!this.filterChange.includes("roomFeatures")){
        this.tourRoomFeaturesList = this.tourRoomFeaturesList.map((x) => {
          let isIncludes = data.RoomCategoryFilters.map(x2 => x2.Key).includes(x.Key)
          if (!isIncludes && !this.tourRoomFeaturesChecked[x.Key]){
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        })
      }
      if (!this.filterChange.includes("tourHotel")) {
        const hasHotelOnMap = this.$route.fullPath.includes("hotelOnMap");
        this.tourHotelList = this.tourHotelList.map((x) => {
          let isIncludes = data.Hotels.map(x2 => x2.Key).includes(x.Key);
          if (!isIncludes && !this.tourHotelChecked[x.Key] && !hasHotelOnMap) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }

      this.tourClassList = this.tourClassList.map((x) => {
        // Combo Tariff
        // return x.map(x2 => {
        //     let isIncludes = data.FlightTariffs.map(x3 => x3.Key).includes(x2.Key);
        //     x2.isDisabled = !isIncludes && !this.tourClassChecked[x2.Key];
        //
        //     return x2
        // });
        let isIncludes = data.FlightTariffs.map(x2 => x2.Key).includes(x.Key)
        if (!isIncludes && !this.tourClassChecked[x.Key]) {
          x.isDisabled = true
        } else {
          x.isDisabled = false
        }
        return x
      });

      if (!this.filterChange.includes("tourDepartureAirports")) {
        this.tourDepartureList = this.tourDepartureList.map((x) => {
          let isIncludes = data.DepartureAirports.map(x2 => x2.Key).includes(x.Key)
          if (!isIncludes && !this.tourDepartureAirportsChecked[x.Key]) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }

      if (!this.filterChange.includes("tourArrivalAirports")) {
        this.tourArrivalList = this.tourArrivalList.map((x) => {
          let isIncludes = data.ArrivalAirports.map(x2 => x2.Key).includes(x.Key)
          if (!isIncludes && !this.tourArrivalAirportsChecked[x.Key]) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }

      if (!this.filterChange.includes("tourAirlines")) {
        this.tourAirlineList = this.tourAirlineList.map((x) => {
          let isIncludes = data.Airlines.map(x2 => x2.Key).includes(x.Key)
          if (!isIncludes && !this.tourAirlinesChecked[x.Key]) {
            x.isDisabled = true
          } else {
            x.isDisabled = false
          }
          return x
        });
      }
    },
    setSecondFilterHotels()
    {
      let filters=this.selectedFilters;

      let data = this.$store.getters['hotels/getSecondaryFiltersResult'];
      if (!data) return
      if (!Object.keys(data).length)
        return;

      let hotelNames = [];
      let uniqueHotels = data.Hotels.filter(x => {
        if (!hotelNames.includes(x.Name)) {
          hotelNames.push(x.Name);
          return x
        }
      });
      this.tourHotelList = this.$store.getters['quicksort'](uniqueHotels, "Name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourHotelChecked).length) {
        let checked=filters.filter(f=>{
          if(f.Type=="Hotel" && f.Key==x.Key)
          {
            return f;
          }
        });

        if(checked && checked.length>0)
        {
          this.$set(this.tourHotelChecked, x.Key, true)
        }
        else{
          this.$set(this.tourHotelChecked, x.Key, false)
        }
       
        // }
        return x
      });
    },
    setSecondFilters() {
      let data = this.$store.getters['hotels/getSecondaryFiltersResult'];
      if (!data) return
      if (!Object.keys(data).length)
        return;

      this.tourProgramList = this.$store.getters['quicksort'](data.TourPrograms, "Name").map((x) => {
        x.isDisabled = false;
        x.isShow = true;
        x.price = "";
        // if (!Object.keys(this.tourProgramChecked).length) {
        this.$set(this.tourProgramChecked, x.Key, false)
        // }
        return x
      });

      this.tourCitiesList = this.$store.getters['quicksort'](data.HotelCities, "name").map((x) => {
        x.isDisabled = false;
        x.isShow = true;
        // if (!Object.keys(this.tourCitiesChecked).length) {
        this.$set(this.tourCitiesChecked, x.Key, false)
        // }
        return x
      });

      this.tourResortList = this.$store.getters['quicksort'](data.HotelResorts, "Name").map((x) => {
        x.isDisabled = false;
        x.isShow = true;
        // if (!Object.keys(this.tourResortChecked).length) {
        this.$set(this.tourResortChecked, x.Key, false)
        // }
        return x
      });
      let hotelCategories = data.HotelCategories;
      if (this.useHotelCategoryGlobalCode) {
        hotelCategories = this.groupByGlobalCode(JSON.parse(JSON.stringify(data.HotelCategories)));
      }
      this.tourCategoryList = this.$store.getters['quicksort'](hotelCategories, "Name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourCategoryChecked).length) {
        this.$set(this.tourCategoryChecked, x.Key, false)
        // }
        return x
      });


      let pansions = data.Pansions;
      if (this.usePansionGlobalCode) {
        pansions = this.groupByGlobalCode(JSON.parse(JSON.stringify(data.Pansions)))
      }
      this.tourFoodList = this.$store.getters['quicksort'](pansions, "Name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourFoodChecked).length) {
        this.$set(this.tourFoodChecked, x.Key, false)
        // }
        return x
      });

      let uniqueKey = [];
      this.tourHotelTypeList = this.$store.getters['quicksort'](data.HotelTypes, "name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourHotelTypeChecked).length) {
        this.$set(this.tourHotelTypeChecked, x.key, false)
        // }
        return x
      }).filter(x => {
        if (!uniqueKey.includes(x.key)) {
          uniqueKey.push(x.key)
          return x
        }
      });

      let hotelNames = [];
      let uniqueHotels = data.Hotels.filter(x => {
        if (!hotelNames.includes(x.Name)) {
          hotelNames.push(x.Name);
          return x
        }
      });
      this.tourHotelList = this.$store.getters['quicksort'](uniqueHotels, "Name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourHotelChecked).length) {
        this.$set(this.tourHotelChecked, x.Key, false)
        // }
        return x
      });

      let roomFeatures = data.RoomCategoryFilters;
        if(roomFeatures) {
            this.tourRoomFeaturesList = this.$store.getters['quicksort'](roomFeatures, "Name").map((x) => {
            x.isShow = true;
            // if (!Object.keys(this.tourRoomFeaturesChecked).length) {
            this.$set(this.tourRoomFeaturesChecked, x.Key, false)
            // }
            return x
          })
        }
     

      // Combo Tariff
      // const cashClassNames = [];
      // const tourClassList = [];
      // this.$store.getters['quicksort'](data.FlightTariffs, "Name").forEach((x) => {
      //     this.$set(this.tourClassChecked, x.Key, false);
      //     const index = cashClassNames.indexOf(x.Name);
      //     if (index === -1) {
      //         cashClassNames.push(x.Name);
      //         tourClassList.push([x])
      //     } else {
      //         tourClassList[index].push(x);
      //     }
      //
      // });
      // this.tourClassList = [...tourClassList];
      this.tourClassList = this.$store.getters['quicksort'](data.FlightTariffs, "Name").map((x) => {
        // if (!Object.keys(this.tourHotelChecked).length) {
        this.$set(this.tourClassChecked, x.Key, false)
        // }
        return x
      });

      this.tourDepartureList = this.$store.getters['quicksort'](data.DepartureAirports, "Name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourDepartureAirportsChecked).length) {
        this.$set(this.tourDepartureAirportsChecked, x.Key, false)
        // }
        return x
      });

      this.tourArrivalList = this.$store.getters['quicksort'](data.ArrivalAirports, "Name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourArrivalAirportsChecked).length) {
        this.$set(this.tourArrivalAirportsChecked, x.Key, false)
        // }
        return x
      });

      this.tourAirlineList = this.$store.getters['quicksort'](data.Airlines, "Name").map((x) => {
        x.isShow = true;
        // if (!Object.keys(this.tourAirlinesChecked).length) {
        this.$set(this.tourAirlinesChecked, x.Key, false)
        // }
        return x
      });
    },
    setHotelForCanaryEasy() {
      const hotelsTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));
      if (!this.easySearchFilterForHotels || !hotelsTourToCombo?.isHotel) return

      const hotel = this.tourHotelList.find(x => x.Key === hotelsTourToCombo.hotelKey);
      if (hotel) {
        this.tourHotelList = this.tourHotelList.filter(x => x.Key === hotelsTourToCombo.hotelKey)
        hotel.isDisabledAndShow = true
        return
      }

      this.tourHotelList = [{Name: hotelsTourToCombo.hotelName, Key: hotelsTourToCombo.hotelKey, isShow: true, isDisabledAndShow: true}]
      this.$set(this.tourHotelChecked, hotelsTourToCombo.hotelKey, false)
    },
    setResortForCanaryEasy() {
      const hotelsTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));
      if (!this.easySearchFilterForHotels || !hotelsTourToCombo?.isResort) return

      const resort = this.tourResortList.find(x => x.Key === hotelsTourToCombo.resortKey);
      if (resort) {
        this.tourResortList = this.tourResortList.filter(x => x.Key === hotelsTourToCombo.resortKey)
        resort.isDisabledAndShow = true
        return
      }

      this.tourResortList = [{Name: hotelsTourToCombo.resortName, Key: hotelsTourToCombo.resortKey, isShow: true, isDisabledAndShow: true}]
      this.$set(this.tourResortChecked, hotelsTourToCombo.resortKey, false)
    },
    setCityForCanaryEasy() {
      const hotelsTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));
      if (!this.easySearchFilterForHotels || !hotelsTourToCombo?.isCity || hotelsTourToCombo.cityKey === -1) return

      const city = this.tourCitiesList.find(x => x.Key === hotelsTourToCombo.cityKey);
      if (city) {
        this.tourCitiesList = this.tourCitiesList.filter(x => x.Key === hotelsTourToCombo.cityKey)
        city.isDisabledAndShow = true
        return
      }

      this.tourCitiesList = [{Name: hotelsTourToCombo.cityName, Key: hotelsTourToCombo.cityKey, isShow: true, isDisabledAndShow: true}]
      this.$set(this.tourCitiesChecked, hotelsTourToCombo.cityKey, false)
    },
    groupByGlobalCode(arr) {
      const res = [];
      arr.forEach(x => {
        let index = -1;

        if (x.GlobalCode) {
          const globalCodes = res.map(x2 => x2.GlobalCode);
          index = globalCodes.indexOf(x.GlobalCode);
          x.Name = x.GlobalCode
        }

        if (index !== -1) {
          res[index].Key.push(x.Key)
        } else {
          x.Key = [x.Key];
          res.push(x)
        }
      });

      return res
    },
    changeSecondFilter(type, val, allParams, sendRequest = true) {
      let notRequest = false;

      switch (type) {
        case "price":
          this.localSecondFilters.price = val.slice()
          break;
          case "emptyPlace":
              this.localSecondFilters.HotelQuota = this.defaultHotelFilter.find(x => x.isChecked).value;
              this.localSecondFilters.AviaQuota = this.defaultAirFilter.find(x => x.isChecked).value;
              this.localSecondFilters.BusTransferQuota = this.defaultBusFilter.find(x => x.isChecked).value;
              this.localSecondFilters.RailwayTransferQuota = this.defaultRailwayFilter.find(x => x.isChecked).value;
          break;

        case "tourProgram":
          this.localSecondFilters.tourProgram = this.tourProgramList.filter((x) => {
            if (this.tourProgramChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourCities":
          this.localSecondFilters.tourCities = this.tourCitiesList.filter((x) => {
            if (this.tourCitiesChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourResort":
          this.localSecondFilters.tourResort = this.tourResortList.filter((x) => {
            if (this.tourResortChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourCategory":
          this.localSecondFilters.tourCategory = this.tourCategoryList.filter((x) => {
            if (this.tourCategoryChecked[x.Key]) {
              return x
            }
          })

          if (this.getWindowSettings.commonFiltersForHotels) {
            const tourCategoryKeys = this.localSecondFilters.tourCategory.map(x => x.Key).flat();

            if (this.checkFilterSelectForCategory || (!this.checkFilterSelect && !tourCategoryKeys.length)) {
              this.tourHotelList = this.$store.getters['quicksort'](this.cashSecondFilters.Hotels, "Name")
              break
            }

            this.setFiltersParamsInUrlNotRequest({params: "cats", values: tourCategoryKeys, type: "tourCategory"});
            this.filterChange = this.filterChange.filter(x => x !== "tourHotel")
            notRequest = true;
          }
          break;

        case "tourFood":
          this.localSecondFilters.tourFood = this.tourFoodList.filter((x) => {
            if (this.tourFoodChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourHotelType":
          this.localSecondFilters.tourHotelType = this.tourHotelTypeList.filter((x) => {
            if (this.tourHotelTypeChecked[x.key]) {
              return x
            }
          })
          if (this.tourHotelTypeCombination) {
            this.localSecondFilters.tourHotelTypeCombination = true;
          } else {
            this.localSecondFilters.tourHotelTypeCombination = false;
          }
          break;

        case "roomFeatures":
          this.localSecondFilters.roomFeatures = this.tourRoomFeaturesList.filter((x) => {
            if (this.tourRoomFeaturesChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourHotel":
              this.localSecondFilters.tourHotel = this.tourHotelList.filter((x) => {
                  if (this.tourHotelChecked[x.Key]) {
                      return x
                  }
              });
              if (this.tourHotelCombination) {
                  this.localSecondFilters.tourHotelCombination = true;
              } else {
                  this.localSecondFilters.tourHotelCombination = false;
              }

              if (this.getWindowSettings.commonFiltersForHotels) {
                notRequest = true;
                const hotelsKeys = this.localSecondFilters.tourHotel.map(x => x.Key);
                this.setFiltersParamsInUrlNotRequest({params: "hotels", values: hotelsKeys, type: "tourHotel"});
              }
          break;

        case "tourClass":
          // this.localSecondFilters.tourClass = this.tourClassList.flat(1).filter((x) => { // Combo Tariff
          this.localSecondFilters.tourClass = this.tourClassList.filter((x) => {
            if (this.tourClassChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourClassMulty":
          this.localSecondFilters.tourClassMulty = val
          break;

        case "tourTransplantation":
          this.localSecondFilters.tourTransplantation = this.tourTransplantationList.filter((x) => {
            if (x.isChecked) {
              return x
            }
          })
          break;

        case "tourTransplantationTo":
          this.localSecondFilters.tourTransplantationTo = this.tourTransplantationListTo.filter((x) => {
            if (x.isChecked) {
              return x
            }
          })
          break;

        case "tourDepartureAirports":
          this.localSecondFilters.tourDepartureAirports = this.tourDepartureList.filter((x) => {
            if (this.tourDepartureAirportsChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourArrivalAirports":
          this.localSecondFilters.tourArrivalAirports = this.tourArrivalList.filter((x) => {
            if (this.tourArrivalAirportsChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourAirlines":
          this.localSecondFilters.tourAirlines = this.tourAirlineList.filter((x) => {
            if (this.tourAirlinesChecked[x.Key]) {
              return x
            }
          })
          break;

        case "tourAirlinesMulty":
          this.localSecondFilters.tourAirlinesMulty = val
          break;

        case "departureTime":
          this.localSecondFilters.departureTime = val.slice()
          break;

        case "arrivalTime":
          this.localSecondFilters.arrivalTime = val.slice()
          break;

        case "changeAll":
          this.localSecondFilters.price = this.priceChange ? allParams.price.slice() : [];
          this.filterChange.push("tourPrice");
          this.filterChange.push("tourPlace");
          this.localSecondFilters.tourProgram = this.tourProgramList.filter((x) => {
            if (this.tourProgramChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourProgram.length ? this.filterChange.push("tourProgram") : null;
          this.localSecondFilters.tourCities = this.tourCitiesList.filter((x) => {
            if (this.tourCitiesChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourCities.length ? this.filterChange.push("tourCities") : null;
          this.localSecondFilters.tourResort = this.tourResortList.filter((x) => {
            if (this.tourResortChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourResort.length ? this.filterChange.push("tourResort") : null;
          this.localSecondFilters.tourCategory = this.tourCategoryList.filter((x) => {
            if (this.tourCategoryChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourCategory.length ? this.filterChange.push("tourCategory") : null;
          this.localSecondFilters.tourFood = this.tourFoodList.filter((x) => {
            if (this.tourFoodChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourFood.length ? this.filterChange.push("tourFood") : null;
          this.localSecondFilters.tourHotelType = this.tourHotelTypeList.filter((x) => {
            if (this.tourHotelTypeChecked[x.key]) {
              return x
            }
          });
          this.localSecondFilters.tourHotelType.length ? this.filterChange.push("tourHotelType") : null;
          this.localSecondFilters.roomFeatures = this.tourRoomFeaturesList.filter((x) => {
            if (this.tourRoomFeaturesChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.roomFeatures.length ? this.filterChange.push("roomFeatures") : null;
          this.localSecondFilters.tourHotel = this.tourHotelList.filter((x) => {
            if (this.tourHotelChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourHotel.length ? this.filterChange.push("tourHotel") : null;
          // this.localSecondFilters.tourClass = this.tourClassList.flat(1).filter((x) => { // Combo Tariff
          this.localSecondFilters.tourClass = this.tourClassList.filter((x) => {
            if (this.tourClassChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourClass.length ? this.filterChange.push("tourClass") : null;
          this.localSecondFilters.tourClassMulty = allParams.classMulty;
          this.filterChange.push("classMulty")
          this.localSecondFilters.tourTransplantation = this.tourTransplantationList.filter((x) => {
            if (x.isChecked) {
              return x
            }
          });
          this.localSecondFilters.tourTransplantation.length ? this.filterChange.push("tourTransplantation") : null;
          this.localSecondFilters.tourDepartureAirports = this.tourDepartureList.filter((x) => {
            if (this.tourDepartureAirportsChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourDepartureAirports.length ? this.filterChange.push("tourDepartureAirports") : null;
          this.localSecondFilters.tourArrivalAirports = this.tourArrivalList.filter((x) => {
            if (this.tourArrivalAirportsChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourArrivalAirports.length ? this.filterChange.push("tourArrivalAirports") : null;
          this.localSecondFilters.tourAirlines = this.tourAirlineList.filter((x) => {
            if (this.tourAirlinesChecked[x.Key]) {
              return x
            }
          });
          this.localSecondFilters.tourAirlines.length ? this.filterChange.push("tourAirlines") : null;
          this.localSecondFilters.tourAirlinesMulty = allParams.airlinesMulty;
          this.filterChange.push("tourAirlinesMulty");
          this.localSecondFilters.departureTime = allParams.dTime.slice();
          if (this.localSecondFilters.departureTime[0] !== this.minutsToTime(this.departureTime[0]) ||
            this.localSecondFilters.departureTime[1] !== this.minutsToTime(this.departureTime[1])) {
            this.dTimeChange = true
          }
          this.filterChange.push("departureTime");
          this.localSecondFilters.arrivalTime = allParams.aTime.slice();
          if (this.localSecondFilters.arrivalTime[0] !== this.minutsToTime(this.arrivalTime[0]) ||
            this.localSecondFilters.arrivalTime[1] !== this.minutsToTime(this.arrivalTime[1])) {
            this.aTimeChange = true
          }
          this.filterChange.push("arrivalTime");
          break;
      }

      this.localSecondFilters.price = this.priceChange ? this.localSecondFilters.price : [];

      if (this.getSearchSecondParamsCounter === 0 && this.getMainSearchCount <= 1 && this.checkFilterSelect) {
        this.$store.commit("hotels/" + mTypesHotels.M_SET_FIRST_SEARCH_WITH_PARAMS, true)
        this.$store.commit("hotels/" + mTypesHotels.M_SET_FIRST_SEARCH, false)
      } else {
        this.$store.commit("hotels/" + mTypesHotels.M_SET_FIRST_SEARCH_WITH_PARAMS, false)
      }

      return new Promise(resolve => {
          if (sendRequest) {
          if (this.cashLocalSecondParams === JSON.stringify(this.localSecondFilters)) {
              bus.$emit('hotels_second_filters_changed')
              resolve(true);
              return
          }
          this.cashLocalSecondParams = JSON.stringify(this.localSecondFilters);
          if (!this.settings.UseApplyFiltersButton || this.getWindowSettings.commonFiltersForHotels && !notRequest) {
            this.pageLoaderCountStatus++;
            this.sendSecondFilterParams(false).then(() => {
              this.pageLoaderCountStatus--
            })
          } else {
            bus.$emit('hotels_second_filters_changed')
          }
          resolve(true)
        } else {
          this.loaderStatus = false;
          resolve(true)
        }
      })
    },
      changePrice(e) {
      this.priceChange = true;
      this.filterChange.push("tourPrice");
      this.availabilityPrice.splice() //для реактивности Vue
      if (this.getWindowSettings.commonFiltersForHotels && this.searched) {
        this.addMinMaxPriceToUrl(this.availabilityPrice[0], this.availabilityPrice[1]);
      }
      if (this.getWindowSettings.commonFiltersForHotels) {
        this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
        this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
      }

      if (this.searched) this.changeSecondFilter('price', e); // добавил проверку что-бы при включении опции commonFiltersForHotels не выдавало ошибку в фильтре "Диапазон цен"
    },
    changeTourPlace(key, typeTransport) {
        if (!this.getWindowSettings.commonFiltersForHotels) return

        this.setDefaultFilter(key, typeTransport);
        this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
    },
    setDefaultFilter(key, typeTransport) {
          if (typeTransport == "aviaQuota") {
              this.defaultAirFilter = this.defaultAirFilter.map((x) => {
                  x.isChecked = x.value === key;
                  return x
              });
              this.$store.commit("hotels/" + mTypesHotels.M_SET_AVIA_QUOTA, key)
          }

          if (typeTransport == "hotelQuota") {
              this.defaultHotelFilter = this.defaultHotelFilter.map((x) => {
                  x.isChecked = x.value === key;
                  return x
              });
              this.$store.commit("hotels/" + mTypesHotels.M_SET_HOTEL_QUOTA_FOR_HOTELS, key)
          }

          if (typeTransport == "busTransferQuota") {
              this.defaultBusFilter = this.defaultBusFilter.map((x) => {
                  x.isChecked = x.value === key;
                  return x
              });
              this.$store.commit("hotels/" + mTypesHotels.M_SET_BUS_QUOTA, key)
          }
          if (typeTransport == "trainTransferQuota") {
              this.defaultRailwayFilter = this.defaultRailwayFilter.map((x) => {
                  x.isChecked = x.value === key;
                  return x
              });
              this.$store.commit("hotels/" + mTypesHotels.M_SET_RAILWAY_QUOTA, key)
          }
    },
    initialDefaultQuota() {
          this.defaultAirFilter = JSON.parse(JSON.stringify(this.quotaItems))
          this.defaultHotelFilter = JSON.parse(JSON.stringify(this.quotaItems))
          this.defaultBusFilter = JSON.parse(JSON.stringify(this.quotaItems))
          this.defaultRailwayFilter = JSON.parse(JSON.stringify(this.quotaItems))

          let params = this.$route.params.searchParams;

          if (params && !this.$route.fullPath.includes("Individuals/Avia")) {
              params = params.split("&");
              params.forEach(x => {
                  if (x.indexOf("aviaQuota") !== -1) {
                    this.defaultAirFilter = this.defaultAirFilter.map((x2) => {
                        if (x.split("=")[1] == x2.value) {
                            x2.isChecked = true;
                            this.$store.commit("hotels/" + mTypesHotels.M_SET_AVIA_QUOTA, x.split("=")[1]);
                        } else {
                            x2.isChecked = false
                        }
                          return x2
                    })
                  } else if (x.indexOf("hotelQuota") !== -1) {
                    this.defaultHotelFilter = this.defaultHotelFilter.map((x2) => {
                        if (x.split("=")[1] == x2.value) {
                            x2.isChecked = true;
                            this.$store.commit("hotels/" + mTypesHotels.M_SET_HOTEL_QUOTA_FOR_HOTELS, x.split("=")[1]);
                        } else {
                            x2.isChecked = false
                        }
                          return x2
                    })
                  } else if (x.indexOf("busTransferQuota") !== -1) {
                    this.defaultBusFilter = this.defaultBusFilter.map((x2) => {
                        if (x.split("=")[1] == x2.value) {
                            x2.isChecked = true;
                            this.$store.commit("hotels/" + mTypesHotels.M_SET_BUS_QUOTA, x.split("=")[1]);
                        } else {
                            x2.isChecked = false
                        }
                          return x2
                    })
                  } else if (x.indexOf("trainTransferQuota") !== -1) {
                    this.defaultRailwayFilter = this.defaultRailwayFilter.map((x2) => {
                        if (x.split("=")[1] == x2.value) {
                            x2.isChecked = true;
                            this.$store.commit("hotels/" + mTypesHotels.M_SET_RAILWAY_QUOTA, x.split("=")[1]);
                        } else {
                            x2.isChecked = false
                        }
                          return x2
                      })
                  }
              })
          } else {
              this.defaultAirFilter = this.defaultAirFilter.map((x) => {
                  if (this.settings.DefaultAirFilter == x.value) {
                      x.isChecked = true;
                      this.$store.commit("hotels/" + mTypesHotels.M_SET_AVIA_QUOTA, x.value);
                  } else {
                      x.isChecked = false
                  }
                  return x
              });

              this.defaultHotelFilter = this.defaultHotelFilter.map((x) => {
                  if (this.settings.DefaultHotelFilter == x.value) {
                      x.isChecked = true;
                      this.$store.commit("hotels/" + mTypesHotels.M_SET_HOTEL_QUOTA_FOR_HOTELS, x.value)
                  } else {
                      x.isChecked = false
                  }
                  return x
              });

              this.defaultBusFilter = this.defaultBusFilter.map((x) => {
                  if (this.settings.DefaultBusFilter == x.value) {
                      x.isChecked = true;
                      this.$store.commit("hotels/" + mTypesHotels.M_SET_BUS_QUOTA, x.value)
                  } else {
                      x.isChecked = false
                  }
                  return x

              });

              this.defaultRailwayFilter = this.defaultRailwayFilter.map((x) => {
                  if (this.settings.DefaultRailwayFilter == x.value) {
                      x.isChecked = true;
                      this.$store.commit("hotels/" + mTypesHotels.M_SET_RAILWAY_QUOTA, x.value)
                  } else {
                      x.isChecked = false
                  }
                  return x
              });
            }
    },
    changeTourProgram(index, val) {
      if (index === 'all') {
        for (const key in this.tourProgramChecked) {
          this.tourProgramChecked[key] = false
        }
        this.filterChange = this.filterChange.filter(x => x !== "tourProgram")

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      } else {
        this.tourProgramChecked[index] = val;
        let isSomeChecked = Object.values(this.tourProgramChecked).some(x => x);
        if (isSomeChecked) {
          if (!this.filterChange.includes("tourProgram")) {
            this.filterChange.push("tourProgram");
          }
        } else {
          this.filterChange = this.filterChange.filter(x => x !== "tourProgram")
        }

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      }

      this.changeSecondFilter('tourProgram')
    },
    changeTourCities(index, val) {
      if (index === 'all') {
        for (const key in this.tourCitiesChecked) {
          this.tourCitiesChecked[key] = false
        }
        this.filterChange = this.filterChange.filter(x => x !== "tourCities")

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      } else {
        this.tourCitiesChecked[index] = val;
        let isSomeChecked = Object.values(this.tourCitiesChecked).some(x => x);
        if (isSomeChecked) {
          if (!this.filterChange.includes("tourCities")) {
            this.filterChange.push("tourCities");
          }
        } else {
          this.filterChange = this.filterChange.filter(x => x !== "tourCities")
        }

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      }

      this.changeSecondFilter('tourCities')

    },
    changeTourResort(index, val) {
      if (index === 'all') {
        for (const key in this.tourResortChecked) {
          this.tourResortChecked[key] = false
        }
        this.filterChange = this.filterChange.filter(x => x !== "tourResort")

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      } else {
        this.tourResortChecked[index] = val;
        let isSomeChecked = Object.values(this.tourResortChecked).some(x => x);
        if (isSomeChecked) {
          if (!this.filterChange.includes("tourResort")) {
            this.filterChange.push("tourResort");
          }
        } else {
          this.filterChange = this.filterChange.filter(x => x !== "tourResort")
        }

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      }

      this.changeSecondFilter('tourResort')
    },
    changeTourCategory(index, val) {
      if (index === 'all') {
        for (const key in this.tourCategoryChecked) {
          this.tourCategoryChecked[key] = false
        }
        this.filterChange = this.filterChange.filter(x => x !== "tourCategory")

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      } else {
        this.tourCategoryChecked[index] = val;
        let isSomeChecked = Object.values(this.tourCategoryChecked).some(x => x);
        if (isSomeChecked) {
          if (!this.filterChange.includes("tourCategory")) {
            this.filterChange.push("tourCategory");
          }
        } else {
          this.filterChange = this.filterChange.filter(x => x !== "tourCategory")
        }

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }

      }

      this.changeSecondFilter('tourCategory')
    },
    changeTourFood(index, val) {
      if (index === 'all') {
        for (const key in this.tourFoodChecked) {
          this.tourFoodChecked[key] = false
        }
        this.filterChange = this.filterChange.filter(x => x !== "tourFood")

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      } else {
        this.tourFoodChecked[index] = val;
        let isSomeChecked = Object.values(this.tourFoodChecked).some(x => x);
        if (isSomeChecked) {
          if (!this.filterChange.includes("tourFood")) {
            this.filterChange.push("tourFood");
          }
        } else {
          this.filterChange = this.filterChange.filter(x => x !== "tourFood")
        }

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      }

      this.changeSecondFilter('tourFood')

    },
     changeTourHotelType(index, val) {
      if (index === 'all') {
        for (const key in this.tourHotelTypeChecked) {
          this.tourHotelTypeChecked[key] = false
        }
        this.filterChange = this.filterChange.filter(x => x !== "tourHotelType")

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
      } else {
        this.tourHotelTypeChecked[index] = val;
        let isSomeChecked = Object.values(this.tourHotelTypeChecked).some(x => x);
        if (isSomeChecked) {
          if (!this.filterChange.includes("tourHotelType")) {
            this.filterChange.push("tourHotelType");
          }
        } else {
          this.filterChange = this.filterChange.filter(x => x !== "tourHotelType")
        }

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }
     }

      this.$nextTick(() => {
          this.changeSecondFilter('tourHotelType') // Без некст тика не успевает отработать отмена поиска по комбинации
      });
     },
      changeRoomFeatures(index, val) {
        if (index === 'all') {
          for (const key in this.tourRoomFeaturesChecked) {
            this.tourRoomFeaturesChecked[key] = false
          }
          this.filterChange = this.filterChange.filter(x => x !== "roomFeatures")

          if (this.getWindowSettings.commonFiltersForHotels) {
            this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
            this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
          }
        } else {
          this.tourRoomFeaturesChecked[index] = val;
          let isSomeChecked = Object.values(this.tourRoomFeaturesChecked).some(x => x);
          if (isSomeChecked) {
            if (!this.filterChange.includes("roomFeatures")) {
              this.filterChange.push("roomFeatures");
            }
          } else {
            this.filterChange = this.filterChange.filter(x => x !== "roomFeatures")
          }

          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }

        this.changeSecondFilter('roomFeatures')

      },
      changeTourHotelTypeCombination (e) {
        this.tourHotelTypeCombination = e;

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }

        this.$nextTick(() => {
            this.changeSecondFilter('tourHotelType') // Без некст тика не успевает отработать отмена поиска по комбинации
        });
      },
     changeTourHotelCombination(e) {
        this.tourHotelCombination = e;

        if (this.getWindowSettings.commonFiltersForHotels) {
          this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
          this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
        }

        this.$nextTick( () => {
            this.changeSecondFilter('tourHotel'); // Без некст тика не успевает отработать отмена поиска по комбинации
        });
      },
      changeTourHotel(index, val) {
        if (index === 'all') {
          for (const key in this.tourHotelChecked) {
            this.tourHotelChecked[key] = false;
          }
          this.filterChange = this.filterChange.filter(x => x !== "tourHotel")

          if (this.getWindowSettings.commonFiltersForHotels) {
            this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false) // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
            this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
          }

          this.filterHotelsBySelected(false)
          this.showSelectedHotels = false
        } else { 
          this.tourHotelChecked[index] = val;
          let isSomeChecked = Object.values(this.tourHotelChecked).some(x => x)
          if (isSomeChecked) {
            if (!this.filterChange.includes("tourHotel")) this.filterChange.push("tourHotel")
          } else {
            this.filterChange = this.filterChange.filter(x => x !== "tourHotel");
            this.showSelectedHotels = false;
            this.filterHotelsBySelected(false)
          }

          if (this.getWindowSettings.commonFiltersForHotels) {
            this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false) // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
            this.$store.commit("hotels/" + mTypesHotels.M_SET_CLICK_SEARCH, false) // нужно что-бы результат не менялся при первом клике по фильтру после поиска в режиме commonFiltersForHotels
          }
      }

      this.$nextTick(() => {
          this.changeSecondFilter('tourHotel') // Без некст тика не успевает отработать отмена поиска по комбинации
      });
    },
    // Combo Tariff
    // changeTourClass(arr, val) {
    //     arr.forEach(x => {
    //         this.tourClassChecked[x.Key] = val;
    //         let isSomeChecked = Object.values(this.tourClassChecked).some(x2 => x2);
    //         if (isSomeChecked) {
    //             if (!this.filterChange.includes("tourClass")) {
    //                 this.filterChange.push("tourClass");
    //             }
    //         } else {
    //             this.filterChange = this.filterChange.filter(x2 => x2 !== "tourClass")
    //         }
    //
    //     });
    //     this.changeSecondFilter('tourClass')
    // },
    changeTourClass(index, val) {
      this.tourClassChecked[index] = val;
      let isSomeChecked = Object.values(this.tourClassChecked).some(x => x);
      if (isSomeChecked) {
        if (!this.filterChange.includes("tourClass")) {
          this.filterChange.push("tourClass");
        }
      } else {
        this.filterChange = this.filterChange.filter(x => x !== "tourClass")
      }
      this.changeSecondFilter('tourClass')
    },
    changeTourClassMulty(val) {
      this.filterChange.push("tourClassMulty");
      this.tourClassMulty.isChecked = val;
      this.changeSecondFilter('tourClassMulty', val)
    },
    changeTourTransplantation(index, val) {
      this.filterChange.push("tourTransplantation");
      this.tourTransplantationList[index].isChecked = val;
      this.changeSecondFilter('tourTransplantation')
    },
    changeTourTransplantationTo(index, val) {
      this.filterChange.push("tourTransplantationTo");
      this.tourTransplantationListTo[index].isChecked = val;
      this.changeSecondFilter('tourTransplantationTo')
    },
    changeTourDepartureAirports(index, val) {
      this.tourDepartureAirportsChecked[index] = val;
      let isSomeChecked = Object.values(this.tourDepartureAirportsChecked).some(x => x);
      if (isSomeChecked) {
        if (!this.filterChange.includes("tourDepartureAirports")) {
          this.filterChange.push("tourDepartureAirports");
        }
      } else {
        this.filterChange = this.filterChange.filter(x => x !== "tourDepartureAirports")
      }
      this.changeSecondFilter('tourDepartureAirports')
    },
    changeTourArrivalAirports(index, val) {
      this.tourArrivalAirportsChecked[index] = val;
      let isSomeChecked = Object.values(this.tourArrivalAirportsChecked).some(x => x);
      if (isSomeChecked) {
        if (!this.filterChange.includes("tourArrivalAirports")) {
          this.filterChange.push("tourArrivalAirports");
        }
      } else {
        this.filterChange = this.filterChange.filter(x => x !== "tourArrivalAirports")
      }
      this.changeSecondFilter('tourArrivalAirports')
    },
    changeTourAirlines(index, val) {
      this.tourAirlinesChecked[index] = val;
      let isSomeChecked = Object.values(this.tourAirlinesChecked).some(x => x);
      if (isSomeChecked) {
        if (!this.filterChange.includes("tourAirlines")) {
          this.filterChange.push("tourAirlines");
        }
      } else {
        this.filterChange = this.filterChange.filter(x => x !== "tourAirlines")
      }
      this.changeSecondFilter('tourAirlines')
    },
    changeTourAirlineMulty(val) {
      this.filterChange.push("tourAirlinesMulty");
      this.tourAirlineMulty.isChecked = val;
      this.changeSecondFilter('tourAirlinesMulty', val)
    },
    changeDepartureTime(val) {
      this.dTimeChange = true;
      this.filterChange.push("departureTime");
      this.changeSecondFilter('departureTime', [
        this.minutsToTime(val[0]),
        this.minutsToTime(val[1])
      ])
    },
    changeArrivalTime(val) {
      this.aTimeChange = true;
      this.filterChange.push("arrivalTime");
      this.changeSecondFilter('arrivalTime', [
        this.minutsToTime(val[0]),
        this.minutsToTime(val[1])
      ])
    },
    minutsToTime(val) {
      let hour = Math.floor(val / 60)
      let minute = Math.round(val % 60)
      return (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute)
    },
    getLocalizeByProp(prop) {
      return this.localizeList[prop]
    },
    timeToMinuts(val) {
      let time = val.split(":")
      let t1 = +time[0] * 60
      let t2 = +time[1]
      return t1 + t2
    },
    showPopover(text, e, down = false) {
      let rect = e.target.getBoundingClientRect();
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: text,
        height: rect.height,
        down,

      }

      this.$store.dispatch(typesGlobal.A_SHOW_POPOVER, res);
    },
    clearAllSearchInput() {
      this.searchProgram = "";
      this.searchCities = "";
      this.searchResort = "";
      this.searchCategory = "";
      this.searchFood = "";
      this.searchHotel = "";
      this.searchHotelType = "";
      this.searchDeparture = "";
      this.searchArrival = "";
      this.searchAirline = "";
      
      if (this.getWindowSettings.commonFiltersForHotels) {
        this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false); // скрываем результат поиска при выборе любого фильтра в режиме commonFiltersForHotels
      }

      bus.$emit("left-filters-reset-search-for-hotels")
    },
    changeSelectedFilters(val) {
      this.selectedFilters = [...val.filters];
      this.priceChange = false;
      this.dTimeChange = false;
      this.aTimeChange = false;

      if (val.sendRequest){
        this.changeSecondFiltersOfUrl(false, true)
        // bus.$emit("main-search")
      }
    },
    setFiltersSpace() {
      const mainFilters = document.querySelector("#main-filters");
      const secondFilters = document.querySelector("#secondFilters");
      // const selectedFilters = document.querySelector(".selected-filters");
      const mainSecondFiltersSpace = document.querySelector("#mainSecondFiltersSpace");
      const verticalFiltersMode = document.querySelector(".vertical-filters-mode");

      if (this.fixedFilters) {
        let filtersHeight = 0;

        if (secondFilters) {
          filtersHeight = secondFilters.clientHeight;
        }

        if (this.settings.FiltersDisplayOptions) {
          verticalFiltersMode.style.marginTop =
            mainFilters.clientHeight + filtersHeight + "px";
        } else {
          mainSecondFiltersSpace.style.height =
            mainFilters.clientHeight + filtersHeight + "px";
        }
      } else {
        if (this.settings.FiltersDisplayOptions) {
          verticalFiltersMode.style.marginTop = "0";
        } else {
          mainSecondFiltersSpace.style.height = "0";
        }
      }
    }
  },
  watch: {
    tourRoomFeaturesChecked: {
      deep: true,
      handler() {
        let isSomeChecked = Object.values(this.tourRoomFeaturesChecked).some(x => x);
        if (isSomeChecked) {
          this.headlineCheckbox.roomFeatures = false;
        } else {
          this.headlineCheckbox.roomFeatures = true;
        }
      }
    },
    tourFoodChecked: {
      deep: true,
      handler() {
        let isSomeChecked = Object.values(this.tourFoodChecked).some(x => x);
        if (isSomeChecked) {
          this.headlineCheckbox.pansion = false;
        } else {
          this.headlineCheckbox.pansion = true;
        }
      }
    },
    tourResortChecked: {
      deep: true,
      handler() {
        let isSomeChecked = Object.values(this.tourResortChecked).some(x => x);
        if (isSomeChecked) {
          this.headlineCheckbox.resorts = false;
        } else {
          this.headlineCheckbox.resorts = true;
        }
      }
    },
    tourCategoryChecked: {
      deep: true,
      handler() {
        let isSomeChecked = Object.values(this.tourCategoryChecked).some(x => x);
        if (isSomeChecked) {
          this.headlineCheckbox.category = false;
        } else {
          this.headlineCheckbox.category = true;
        }
      }
    },
    tourProgramChecked: {
      deep: true,
      handler() {
        let isSomeChecked = Object.values(this.tourProgramChecked).some(x => x);
        if (isSomeChecked) {
          this.headlineCheckbox.tourProgram = false;
        } else {
          this.headlineCheckbox.tourProgram = true;
        }
      }
    },
    tourCitiesChecked: {
      deep: true,
      handler() {
        let isSomeChecked = Object.values(this.tourCitiesChecked).some(x => x);
        if (isSomeChecked) {
          this.headlineCheckbox.cities = false;
        } else {
          this.headlineCheckbox.cities = true;
        }
      }
    },
    tourHotelTypeChecked: {
      deep: true,
      handler() {
        let isSomeChecked = Object.values(this.tourHotelTypeChecked).some(x => x);
        if (isSomeChecked) {
           this.headlineCheckbox.hotelType = false;
           this.hideHotelTypeCombination = true;
        } else {
          this.headlineCheckbox.hotelType = true;
          this.hideHotelTypeCombination = false;
          this.tourHotelTypeCombination = false;
        }
      }
    },
    tourHotelChecked: {
          deep: true,
          handler() {
              let isSomeChecked = Object.values(this.tourHotelChecked).some(x => x);
              if (isSomeChecked) {
                  this.headlineCheckbox.hotels = false;
                  this.hideHotelCheck = true;
              } else {
                  this.headlineCheckbox.hotels = true;
                  this.hideHotelCheck = false;
                  this.tourHotelCombination = false;
              }
          }
    },
    collapse(val) {
      let newUrl = this.$route.fullPath.replace("&groupingKeys=32", "");
      if (val) {
        newUrl += "&groupingKeys=32";
      }

      if (this.$route.fullPath !== newUrl)
        this.$router.push(newUrl);

        this.$emit('collapseByHotel', val)
    },
    addintionalPriceHeader(val) {
      if (val.length) {
        this.priceTableLoader = false;
      }
    },
    fixedFilters() {
      this.setFiltersSpace()
    },
    cashSendSecondParams(val) {
      if (val) {
        setTimeout(() => {
          this.cashSendSecondParams = ''
        },0)
      }
    },
    cashLocalSecondParams(val) {
      if (val) {
        setTimeout(() => {
          this.cashLocalSecondParams = ''
        },3000)
      }
    },
    // Combo Tariff (comment)
    selectedFilters: {
      deep: true,
      handler(val) {
        let oldVal = [...this.selectedFiltersOldVal];
        if (JSON.stringify(val) === JSON.stringify(oldVal)) {
          return
        }
        let newSelectedFilters = [];
        val.forEach(x => {
          let helper = 0;
          newSelectedFilters.forEach(x2 => {
            // Проверка дублей
            if (
              x.Type === x2.Type &&
              (x.name && x2.name ? x.name === x2.name : x.Name === x2.Name)
            ){
              helper++
            }
          });
          if (helper < 1) {
            newSelectedFilters.push(x);
          }

        });
        this.selectedFilters = [...newSelectedFilters];
        this.selectedFiltersOldVal = [...newSelectedFilters]
      }
    },
    cashUrl(val) {
      bus.$emit("change-cash-url-of", val)
    },
    pageLoaderCountStatus(val) {
      if (val < 0) this.pageLoaderCountStatus = 0;

      bus.$emit("page-load", val > 0)
    },
    focus(val) {
      if (val) {
        setTimeout(() => {
          this.createPriceTableColumns()
        }, 0)
      }
    },
    secondFilters: {
      deep: true,
      handler() {
        this.disabledSecondFilters();
      }
    },
    searchProgram(val) {
      if (val.length) {
        this.tourProgramList = this.tourProgramList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase()) && !x.price.includes(val)) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourProgramList = this.tourProgramList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchCities(val) {
      if (val.length) {
        this.tourCitiesList = this.tourCitiesList.map(x => {
          if (!x.name.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourCitiesList = this.tourCitiesList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchResort(val) {
      if (val.length) {
        this.tourResortList = this.tourResortList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourResortList = this.tourResortList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchCategory(val) {
      if (val.length) {
        this.tourCategoryList = this.tourCategoryList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourCategoryList = this.tourCategoryList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchFood(val) {
      if (val.length) {
        this.tourFoodList = this.tourFoodList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase()) && !x.Code.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourFoodList = this.tourFoodList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchHotel(val) {
      if (val.length) {
        this.tourHotelList = this.tourHotelList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourHotelList = this.tourHotelList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchHotelType(val) {
      if (val.length) {
        this.tourHotelTypeList = this.tourHotelTypeList.map(x => {
          if (!x.name.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourHotelTypeList = this.tourHotelTypeList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchDeparture(val) {
      if (val.length) {
        this.tourDepartureList = this.tourDepartureList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase()) && !x.Code.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourDepartureList = this.tourDepartureList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchArrival(val) {
      if (val.length) {
        this.tourArrivalList = this.tourArrivalList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase()) && !x.Code.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourArrivalList = this.tourArrivalList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    searchAirline(val) {
      if (val.length) {
        this.tourAirlineList = this.tourAirlineList.map(x => {
          if (!x.Name.toLowerCase().includes(val.toLowerCase())) {
            x.isShow = false
          } else {
            x.isShow = true
          }

          return x
        })
      } else {
        this.tourAirlineList = this.tourAirlineList.map(x => {
          x.isShow = true;
          return x
        })
      }
    },
    priceTableData: {
      deep: true,
      handler() {
        this.setPriceTableData();
        if (this.priceTableReady) {
          this.addintionalPrice = [];
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
    window.removeEventListener("scroll", this.scroll);
    bus.$emit("page-load", false);
  },
  filters: {
    time(val) {
      let hour = Math.floor(val / 60)
      let minute = Math.round(val % 60)
      return (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute)
    },
    removeStar(val) {
      return val.replace(/\*/g, "");
    },
    capitalize(val) {
      val = val[0].toUpperCase() + val.slice(1);
      return val
    }
  }
}
</script>

<style scoped>
/*ADDINTIONAL PRICE START*/
.second-search-bar-wrap {
  position: relative;
  z-index: 1;
}
.second-search-bar-wrap.fixed {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.second-search-bar {
  position: relative;
  background-color: var(--white-color);
  border-top: 1px solid var(--lighten-4-color);
  border-bottom: 1px solid var(--lighten-4-color);
  padding: 0 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.second-search-bar .search-controlers {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.second-search-bar .search-controlers .search-controler-item {
  position: relative;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
}

.second-search-bar .search-controlers .search-controler-item:not(:first-child):before {
  content: '';
  position: absolute;
  top: calc(50% - 10px);
  left: 0;
  background-color: #e0e0e0;
  width: 1px;
  height: 20px;
}

.second-search-bar .search-controlers .search-controler-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  background-color: var(--orange-color);
  height: 4px;
}

.second-search-bar .search-controlers .search-controler-item span {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #727272;
  transition: all .2s;
}

.second-search-bar .search-controlers .search-controler-item.active span {
  color: var(--orange-color);
}

.second-search-bar .search-controlers .search-controler-item .angle-icon {
  margin: 0 0 2px 7px;
  transition: all .2s;
}

.second-search-bar .search-controlers .search-controler-item.active .angle-icon {
  transform: rotate(180deg)
}

.second-search-bar .result-positin-controlers {
  display: grid;
  grid-template-columns: repeat(5, 24px);
  grid-template-rows: 24px;
  grid-gap: 24px;
  align-self: center;
}

.common-result-position-controlers {
  display: grid;
  grid-template-columns: repeat(5, 24px);
  grid-template-rows: 24px;
  grid-gap: 24px;
  align-content: center;
  align-items: center;
}

.second-search-bar .result-positin-controlers .collapse,
.second-search-bar .result-positin-controlers .controler {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s;
}
.second-search-bar .result-positin-controlers .collapse {
  position: relative;
}
.second-search-bar .result-positin-controlers .collapse:after {
  content: "";
  background-color: #E0E0E0;
  width: 1px;
  height: 20px;
  position: absolute;
  top: 2px;
  right: -13px;
}

.second-search-bar-list {
  position: relative;
  width: 100%;
  background-color: var(--white-color);
  padding: 28px 60px 38px;
  overflow: auto;
}
.fixed .second-search-bar-list {
  max-height: calc(100vh - 134px);
}

.price-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(200, 200, 200, .5);
}
/*ADDINTIONAL PRICE END*/

/*AVAILABILITY*/
.availability-filter {
  display: flex;
  justify-content: space-between;
  }

.availability-filter .price-block .price-text {
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--dark-1-color);
  margin-bottom: 24px;
}

.availability-filter .price-block .price-text .blue-text {
  margin-left: 7px;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: var(--primary-color);
}

.availability-filter .availability-checkbox-group-wrap {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 15px;
}

.availability-filter .availability-checkbox-group-wrap .default {
    display: flex;
    align-items: end;
    gap: 20px;
}

.availability-filter .availability-checkbox-group-wrap p {
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: var(--dark-1-color);
    margin-bottom: 14px;
}

.availability-filter .availability-checkbox-group {
  display: grid;
  grid-template-columns: auto auto auto 1fr;
  grid-gap: 28px;
}

.availability-filter .done-btn {
  display: flex;
  align-items: flex-end;
}
/*AVAILABILITY END*/

/*TOUR OPTIONS*/
.tour-options .tour-options-filter {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 40px;
  margin-bottom: 15px;
}
.input-headline-checkbox-container {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}
.tour-options .tour-options-headline {
  flex-shrink: 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: var(--dark-1-color);
}

.tour-options .btn-group {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.tour-options .btn-group .base-button:last-child {
  margin-left: 11px;
}

.tour-options .btn-group::before {
  content: "";
  position: absolute;
  bottom: 78px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: var(--lighten-4-color);
}
.fixed .tour-options .btn-group::before {
  display: none;
}

/* .tour-options .type-search,
.tour-options .program-search {
  max-width: 400px;
} */

.tour-options .options-list {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 175px;
}

.tour-options .options-list .options-item {
  padding: 7px 0;
  border-top: 1px solid var(--lighten-6-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tour-options .options-list .options-item .price-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  color: var(--orange-color);
}
/*TOUR OPTIONS END*/

/*ACCOMMODATION*/
.input-headline-checkbox-small-container {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  justify-content: space-between;
}

.hotel-type-icon {
  margin-right: 10px;
}
.tour-accommodation .tour-accommodation-filter {
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 260px 260px;
  grid-column-gap: 40px;
  grid-row-gap: 30px;
  margin-bottom: 20px;
}
.tour-accommodation .tour-accommodation-filter:before {
  content: '';
  position: absolute;
  top: 50%;
  left: -60px;
  right: -60px;
  height: 1px;
  background-color: #ddd;
}
.tour-accommodation .tour-accommodation-filter .br {
  display: none;

}

.tour-accommodation .tour-accommodation-filter .hotel-filter{
  grid-column: 3 / 5;
}

.tour-accommodation .tour-accommodation-filter .hotel-type-filter{
  grid-column: 1 / 3;
}

.tour-accommodation .tour-accommodation-filter .headline {
  margin-bottom: 10px;
}

.tour-accommodation .tour-accommodation-filter .hotel-type-headline {
  flex-shrink: 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: var(--dark-1-color);
}

.tour-accommodation .headlineCombination {
    justify-content: space-between;
    align-items: center;
    display: flex;
    min-height: 20px;
}

.tour-accommodation .headlineCombinationInfo-container {
    display: flex;
    align-items: center;
    gap: 20px;
}

.tour-accommodation .headlineCombinationInfo {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 500;
}

.tour-accommodation .chekboxCombinationInfo {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: var(--dark-1-color);
}

.tour-accommodation .iconCombination {
    align-self: center;
}
.tour-accommodation .btn-group {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.tour-accommodation .btn-group .base-button:last-child {
  margin-left: 11px;
}

.tour-accommodation .btn-group::before {
  content: "";
  position: absolute;
  bottom: 78px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: var(--lighten-4-color);
}
.fixed .tour-accommodation .btn-group::before {
  display: none;
}

.tour-accommodation .cities-filter .cities-search,
.tour-accommodation .resort-filter .resort-search,
.tour-accommodation .category-filter .category-search,
.tour-accommodation .food-filter .food-search {
  margin-bottom: 20px;
}

.tour-accommodation .accommodation-list {
  height: calc(100% - 35px);
  overflow: auto;
}

.tour-accommodation .accommodation-list.search-list {
  height: calc(100% - 100px);
  overflow: auto;
}

.tour-accommodation .accommodation-item {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}

.star-icon {
  margin-left: 8px;
}
/*ACCOMMODATION END*/

/*FLIGHT*/
.tour-flight .tour-flight-filter {
  position: relative;
  display: grid;
  grid-template-columns: 200px repeat(3, 1fr);
  grid-template-rows: 400px;
  grid-gap: 40px;
  margin-bottom: 20px;
}
.tour-flight .tour-flight-filter .line1 {
  position: absolute;
  top: 50%;
  left: 0;
  right: 360px;
  height: 1px;
  background-color: var(--lighten-4-color);
}
.tour-flight .tour-flight-filter .line2 {
  position: absolute;
  top: 0;
  left: calc(100% - 361px);
  right: 360px;
  height: 100%;
  background-color: var(--lighten-4-color);
}

.tour-flight .tour-flight-filter .headline {
  margin-bottom: 10px;
}

.tour-flight .airport-filter .headline:not(:first-child) {
  margin-top: 20px;
}

.tour-flight .btn-group {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.tour-flight .btn-group .base-button:last-child {
  margin-left: 11px;
}

.tour-flight .btn-group::before {
  content: "";
  position: absolute;
  bottom: 78px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: var(--lighten-4-color);
}
.fixed .tour-flight .btn-group::before {
  display: none;
}

.tour-flight .airline-search,
.tour-flight .arrival-search,
.tour-flight .departure-search {
  margin-bottom: 20px;
}

.tour-flight .flight-list {
  height: calc(50% - 18px);
  overflow: auto;
}

.tour-flight .flight-list.airport-list {
  max-height: calc(50% - 100px);
}

.tour-flight .flight-list.airline-list,
.tour-flight .flight-list.class-list {
  max-height: 96px;
  height: auto;
}

.tour-flight .flight-item {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}

.tour-flight .flight-item.class-combo,
.tour-flight .flight-item.airline-combo {
  padding-top: 10px;
}
.tour-flight .flight-item.airline-combo {
  margin-bottom: 40px;
}

.tour-flight .flight-item .help-icon {
  margin-left: 5px;
  cursor: pointer;
}

.ie .time-filter {
  margin-right: 20px;
}

.time-filter .standard-text {
  margin-bottom: 22px;
  white-space: nowrap;
  display: inline-block;
}
.time-filter .departure-there,
.time-filter .arrival-back {
  width:  calc(100% - 20px);
  height: 50%;
}
.time-filter .arrival-back {
  margin-top: 10px;
}
/*FLIGHT END*/

.not-result-text {
  margin-bottom: 10px;
}

.filters-falidation-popup .btn-group {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.filters-falidation-popup .btn-group .base-button:last-child {
  margin-left: 10px;
}

.btn-group.fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px 60px 36px;
  background: var(--white-color);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  z-index: 1;
}
.btn-group.fixed::before {
  display: none;
}

.vertical-filters-mode .selected-filters {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  border-top: 1px solid var(--lighten-4-color);
  z-index: 2;
}

#hotels-price-table {
  z-index: 1;
}

@media (max-width: 1140px) {
  .second-search-bar-list {
    padding: 28px 20px 38px;
  }
  .tour-flight .tour-flight-filter {
    grid-gap: 20px;
  }

  .tour-accommodation .tour-accommodation-filter {
    grid-gap: 20px;
  }

  .tour-accommodation .tour-accommodation-filter:before {
    left: -20px;
    right: -20px;
  }
}

/* COMMON-FILTERS START*/
.common-base-slider{
  max-width: 280px;
}
.common-search-bar-list {
  position: relative;
  width: 100%;
  background-color: var(--white-color);
  padding: 15px 60px 15px;
  border: 1px solid var(--lighten-7-color);
}
.common-filters {
  max-width: 1200px;
  margin: 0 auto;
  overflow-y: hidden;
  overflow-x: auto;
}
.common-filters-container {
  position: relative;
  display: grid;
  grid-template-rows: 200px 314px;
  grid-row-gap: 15px;
  height: 100%;
  margin-bottom: 15px;
}
.top-block {
  display: flex;
  gap: 15px;
}
.top-left-block {
  flex: 1 1 58.5%;
  display: flex;
  gap: 10px;
  min-width: 630px;
}
.top-right-block {
  flex: 1 1 40%;
}
.bottom-block {
  display: flex;
  gap: 15px;
}
.bottom-left-block {
  flex: 1 1 58.5%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}
.common-category-filter {
  flex: 1 1 25%;
}
.common-food-filter {
  flex: 1 1 25%;
}
.common-room-features-filter {
  flex: 1 1 50%;
}
.common-hotel-type-filter {
  flex: 1 1 50%;
}
.bottom-right-block {
  flex: 1 1 40%;
}
.common-tour-program {
  height: 100%;
}
.common-cities-filter{
  flex: 1 1 25%;
}
.common-resort-filter{
  flex: 1 1 25%;
}
.bottom-left-block .top-row {
  display: flex;
  height: 180px;
  gap: 10px;
  flex: 1 0 180px;
}
.bottom-left-block .bottom-row {
  display: flex;
  height: 100%;
  flex: 0 0 90px;
}
.common-headline-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 7.5px;
}
.common-headline {
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: var(--dark-1-color);
  white-space: nowrap;
}
.common-headline-checkbox-container {
  display: flex;
  align-items: center;
  gap: 5px;
}
.common-input-headline-checkbox-container {
  display: flex;
  gap: 5px;
}
.common-headline-checkbox {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: var(--dark-1-color);
  white-space: nowrap;
}
.common-input-headline {
  margin-bottom: 0;
}
.common-input-header {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 7.5px;
}
.common-input-header-with-chekbox {
  grid-template-columns: auto 1fr auto;
}
.common-list {
  height: calc(100% - 26.5px);
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--lighten-7-color);
  padding: 5px;
}
.common-list-combination {
  height: calc(100% - 56px);
}
.common-input-list {
  height: calc(100% - 51px);
}
.common-input-list-combination {
    height: calc(100% - 80px);
}
.common-headlineCombination {
    align-items: center;
    display: flex;
}
.common-headlineCombinationInfo {
    display: flex;
    gap: 5px;
    justify-content: flex-end;
    align-items: center;
    font-size: 15px;
    margin-bottom: 5px;
}
.common-headlineCombinationInfo-container {
    display: flex;
    justify-content: space-between;
    gap: 10px;
}
.common-chekboxCombinationInfo {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: var(--dark-1-color);
}
.common-item {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.common-program-item {
  justify-content: space-between;
}
.common-price-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  color: var(--orange-color);
}
.common-hotel-filter {
  height: 100%;
}
.common-filters .btn-group {
  display: flex;
  justify-content: space-between;
}

.common-filters .btn-group .btn-subgroup {
  display: flex;
  gap: 20px;
}

.common-availability-filter {
  display: flex;
  border: 1px solid var(--lighten-7-color);
  padding: 10px;
  align-items: center;
  min-width: 630px;
  width: 100%;
  column-gap: calc(100% - 575px);
}

.common-price-block {
  flex: 0 0 300px;
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.common-price-block .price-text {
  font-size: 15px;
}

.common-price-block .price-inputs {
  display: flex;
  gap: 5px;
}

.common-price-block .price-input {
  width: 135px;
  height: 30px;
  border: 2px solid var(--lighten-7-color);
  padding: 5px;
  font-size: 16px;
}

.common-price-block .price-inputs input:focus {
  border: 2px solid var(--primary-color);
  outline: none;
}

.common-price-block .dash {
    align-self: center;
    display: flex;
    background-color: var(--lighten-7-color);
    height: 2px;
    width: 15px;
}

.common-availability-checkbox-group-wrap {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 15px;
}

.common-availability-checkbox-group-wrap .default {
    display: flex;
    align-items: end;
    gap: 20px;
}

.common-availability-checkbox-group-wrap p {
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: var(--dark-1-color);
    margin-bottom: 5px;
}

.common-availability-checkbox-group {
  justify-content: start;
  display: flex;
  gap: 10px;
}
/* COMMON-FILTERS END*/

@media (max-width: 1200px) {
  .second-search-bar .search-controlers .search-controler-item {
    padding: 16px clamp(6px, calc((calc(100vw / 1200) - 0.85px) * 100), 15px);
  }
}
</style>
